<template>
    <div class="bigDiv">
        <div class="leaderBox" v-if="showOrhide">
			<div class="newtext">新手指引</div>
			<img src="../../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
			<img src="../../../assets/images/ylcs1.png" class="steps step1" v-if="status==1">
            <div class="stepbtn" @click="nextStep(status)">
				{{status==1?"我知道了":"我知道了"}}
			</div>
            <div class="bottomTip">
				<el-checkbox v-model="checked">下次不再提示</el-checkbox>
			</div>
		</div>
<!--        <div class="h-crumbOut">-->
<!--            <div class="h-crumbs">-->
<!--                <el-breadcrumb separator="|">-->
<!--                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>-->
<!--                    <el-breadcrumb-item><a href="/">项目管理</a></el-breadcrumb-item>-->
<!--                    <el-breadcrumb-item><a href="/">盈利测算</a></el-breadcrumb-item>-->
<!--                </el-breadcrumb>-->
<!--            </div>-->
<!--        </div>-->
      <Breadtabsheader/>
        <div class="h-piece">
            <div class="h-pieceTitle2">
                <h1>项目信息</h1>
            </div>
            <div class="h-pieceCon2">
                <div class="h-formLine message">
                    <el-form :model="ProMain" label-position="right" ref="formLabelAlign" :inline="true"
                             class="demo-ruleForm h-formbLine" :rules="rules">


                       <!--  <el-form-item prop="quyu" label="区域" :rules="[
								  { required: true, message: '请选择区域', trigger: 'change'},
								]" class="h-elformWrap-2">
                       


                            <el-select v-model="ProMain.quyu" placeholder="请选择">
                                <el-option
                                        v-for="(item) in guoneiquyulist"
                                        :key="item.code"
                                        :label="item.name"
                                        :value="item.code">
                                </el-option>
                            </el-select>


                        </el-form-item> -->
						<!-- <el-form-item
						        label="客户"
						        class="h-elformWrap-2"
						        style="position:relative"
						        prop="xuanzhongren"
						>
						    
						    <el-input v-model="ProMain.xuanzhongren" placeholder="请输入" readonly>
						        <i
						                class="el-icon-search el-input__icon"
						                slot="suffix"
						                @click="tanchuxuanzeren">
						        </i>
						    </el-input>
						</el-form-item> -->
                        <!--                        <el-form-item label="项目名称" class="h-elformWrap-2">-->
                        <!--                            <el-input v-model="ProMain.projectName" placeholder="" disabled="disabled"></el-input>-->
                        <!--                        </el-form-item>-->

                        <!--                        <el-form-item label="开标日期" class="h-elformWrap-2">-->
                        <!--                            <el-input v-model="ProMain.bid" placeholder="" disabled="disabled"></el-input>-->
                        <!--                        </el-form-item>-->
                        <el-form-item label="保修期" class="h-elformWrap-2" prop="repairtype">
                            <el-select v-model="repairtype" placeholder="请选择" @change="repairchangetype">
                                <el-option v-for="item in repairOptions" :key="item.value"
                                           :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>

                        </el-form-item>
						<el-form-item label="投标方式" class="h-elformWrap-2" prop="bidway">
                            <brselect clearable category="cesuan_toubiao" :v="ProMain.bidway"
                                      v-model="ProMain.bidway" @change="toubiaochange"></brselect>

                        </el-form-item>
                        <el-form-item label="预付百分比%" class="h-elformWrap-2" prop="pdpay" v-if="!dailishangsuoding">
                            <el-input v-model="ProMain.pdpay" placeholder="请输入.xxx" @blur="pdpaychange(ProMain.pdpay)"
                                      :disabled="dailishangsuoding"

                            ></el-input>
                        </el-form-item>
                        <el-form-item label="首款百分比%" class="h-elformWrap-2" prop="fdpay" v-if="!dailishangsuoding">
                            <el-input v-model="ProMain.fdpay" placeholder="请输入.xxx" @blur="fdpaychange(ProMain.fdpay)"
                                      :disabled="dailishangsuoding"

                            ></el-input>

                        </el-form-item>
                        <el-form-item label="中款百分比%" class="h-elformWrap-2" prop="mdpay" v-if="!dailishangsuoding">
                            <el-input
                                    v-model="ProMain.mdpay"
                                    placeholder="请输入.xxx"
                                    style="margin-right: 20px;"
									@blur="mdpaychange(ProMain.mdpay)"
                                    :disabled="dailishangsuoding"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item label="尾款百分比%" class="h-elformWrap-2" prop="ldpay" v-if="!dailishangsuoding">
                            <el-input v-model="ProMain.ldpay" placeholder="请输入.xxx" @blur="ldpaychange(ProMain.ldpay)"
                                      :disabled="dailishangsuoding"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="首款天" class="h-elformWrap-2" prop="fdpayday" v-if="!dailishangsuoding">
                            <el-input v-model.number="ProMain.fdpayday" placeholder="请输入"
                                      oninput="value=value.replace(/[^\d]/g, '')"
                                      maxlength="3"  :disabled="dailishangsuoding">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="中款天" class="h-elformWrap-2" prop="mdpayday" v-if="!dailishangsuoding">
                            <el-input v-model.number="ProMain.mdpayday" placeholder="请输入"
                                      oninput="value=value.replace(/[^\d]/g, '')"
                                      maxlength="3"  :disabled="dailishangsuoding">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="尾款天" class="h-elformWrap-2" prop="ldpayday" v-if="!dailishangsuoding">
                            <el-input v-model.number="ProMain.ldpayday" placeholder="请输入"
                                      oninput="value=value.replace(/[^\d]/g, '')"
                                      maxlength="3"  :disabled="dailishangsuoding">
                            </el-input>
                        </el-form-item>

                       <!--  <el-form-item label="送达地址" class="h-elformWrap-2" prop="songdadizhi"
                                      :rules="[{ required: true, message: '请选择送达地址', trigger: 'change'},]">
                            <el-input clearable v-model="ProMain.songdadizhi" readonly>
                                <i
                                        class="el-icon-search el-input__icon"
                                        slot="suffix"
                                        @click="selectAreadialog">
                                </i>
                            </el-input>
                        </el-form-item>

                        <el-form-item label="送达城市" class="h-elformWrap-2"
                                      :rules="[{ required: true, message: '请选择送达城市', trigger: 'change'},]">


                            <el-select v-model="ProMain.songdachengshi" placeholder="送达地址带出" filterable clearable
                                       disabled="disabled">
                                <el-option
                                        v-for="(item,index) in songdachengshilist"
                                        :key="index"
                                        :label="`[${item.code}]${item.name}`"
                                        :value="item.code+'_'+item.name">
                                </el-option>
                            </el-select>


                        </el-form-item> -->






              <!--           <showxuanzerencesuan
                                :visible.sync="xuanzeren"
                                v-if="xuanzeren"
                                ddlx="lengku"
                                @choseObj="shiyongrenxuanze"
                                oneflag
                                title="选择经销商"/> -->
                        <el-form-item
                                class="h-elformWrap-1 ljjrange"
                                label="选择特价有效期"
                                prop="youxiaoqi"
                                :rules="[{ required: true, message: '请选择特价有效期', trigger: 'change'},]">
                                <!-- <el-date-picker
                                        v-model="ProMain.youxiaoqi"
                                        type="daterange"
                                        range-separator=" 至 "
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        style="width: 6rem"
                                        value-format="yyyy-MM-dd"
                                >
                                </el-date-picker> -->
                                <el-date-picker
                                    style="width: 2rem;"
                                    v-model="ProMain.youxiaoqistart"
                                    clearable
                                    type="date"
                                    placeholder="请选择开始时间"
                                    value-format="yyyy-MM-dd" >
                                </el-date-picker>
                                <span class="w-time-to">至</span>
                                <el-date-picker
                                    style="width: 2rem;"
                                    v-model="ProMain.youxiaoqi"
                                    clearable
                                    placeholder="请选择结束时间"
                                    type="date"
                                    value-format="yyyy-MM-dd" >
                                </el-date-picker>
                        </el-form-item>
                        <el-form-item label="驳回审批意见" class="h-elformWrap-2" v-if="shenpiyemian">
                            <el-input v-model="ProMain.shenpiyijian" placeholder="" disabled="disabled"></el-input>
                        </el-form-item>


                        <br>

                        <el-form-item
                                v-if="shenpiyijianshow"
                                label="原始版本查看"
                                class="h-elformWrap-2 "
                                prop="xiangmucode"
                        >

                            <el-button type="text" size="small" class="h-tableLink h-btn"
                                       @click="cesuanbanbenchakan">原始版本查看
                            </el-button>

                        </el-form-item>

                        <br>



                        <!--                        <wuliaomiaoshuSelect :visible.sync="showflag" @choseObj="choseObj" title="选择物料"  v-if="showflag"/>-->

                        <!--                        <br>-->
                        <!--                        <el-form-item label="项目背景" class="h-elformWrap-2">-->
                        <!--                            <el-input v-model="ProMain.projectDescription" placeholder="" disabled="disabled"></el-input>-->
                        <!--                        </el-form-item>-->
                        <!--                        <br>-->
                        <!--                        <el-form-item label="终端成交" class="h-elformWrap-2">-->
                        <!--                            <el-input v-model="ProMain.zhongduanchengjiaojia" placeholder=""-->
                        <!--                                      style="width:200px;" disabled="disabled"></el-input>-->
                        <!--                            &lt;!&ndash;                            <el-select v-model="ProMain.zhongduanchengjiaojia" placeholder="请选择">&ndash;&gt;-->
                        <!--                            &lt;!&ndash;                                <el-option label="类型一" value="type1"></el-option>&ndash;&gt;-->
                        <!--                            &lt;!&ndash;                                <el-option label="类型二" value="type2"></el-option>&ndash;&gt;-->
                        <!--                            &lt;!&ndash;                            </el-select>&ndash;&gt;-->
                        <!--                        </el-form-item>-->
                        <!--                        <el-form-item label="专营商毛利率" class="h-elformWrap-2">-->
                        <!--                            <el-input v-model="ProMain.zhuanyingshangmaolilv" placeholder="" disabled="disabled"></el-input>-->
                        <!--                        </el-form-item>-->

                    </el-form>
					<el-form :model="form" ref="form" class="demo-form-inline" label-position="right"
								v-if="!shenpiyemian">


						<div class="l-style">
						   <div class="cesuantitles">测算型号：</div>
						   <div class="l-styleBox">
							   <div class="l-stylelist" v-for="(item,index) in duoxinghaocesuan" :key="index">
								   <div class="l-styletext">
									   {{item}}
									   <div v-if="!shenpiyemian" class="l-styledel" @click="delwuliao(item)">x</div>
								   </div>
							   </div>
							   <el-button class="h-btn h-bgblueQ2"
										  style="border-radius: 0.2rem;font-size: 0.2rem;margin-left: 0.1rem;padding: 0.05rem 0.1rem;"
										  type="primary"
										  @click="adds" v-if="!shenpiyemian">+
							   </el-button>
						   </div>
					   </div>

						 <!--  <el-form-item label="大类" class="h-elformWrap-2" prop="dalei" :rules="[
								   { required: true, message: '必须输入选项', trigger: 'blur'}]">
							   <el-select v-model="form.dalei" filterable @change="handleItemChange1" placeholder="大类">
								   <el-option
										   v-for="item in list1"
										   :key="item.value"
										   :label="item.prodseries"
										   :value="item.oneLid">
								   </el-option>
							   </el-select>
						   </el-form-item>

						   <el-form-item label="物料" class="h-elformWrap-2">
							   <el-select v-model="form.wuliao"
										  filterable
										  placeholder="物料">
								   <el-option
										   v-for="item in list2"
										   :key="item.value"
										   :label="item.promodel"
										   :value="item.prodcode">
								   </el-option>
							   </el-select>
						   </el-form-item>


						   <el-button class="h-btn h-bBtn h-bgwhite" @click="qingkonghuidiao"
									  style="margin-top:-20px;margin-left: 0.3rem;">清空
						   </el-button>
						   <el-button type="primary" @click="danxinghao" style="margin-top:-20px">单型号测算</el-button>
						   <el-button type="primary" @click="zhuijiaxinghao" style="margin-top:-20px">选择多型号</el-button>


						   <el-form-item label="选中物料号" class="h-elformWrap-2" v-if="duoxinghao">

							   <el-input v-model="duoxinghaocesuan.toString()" placeholder=""
										 disabled="disabled"></el-input>

							   <el-button type="primary" @click="duoxinghaotijiao"
										  style="position:absolute;margin-left:1.2rem;margin-top:-10px">点击填写测算信息
							   </el-button>

						   </el-form-item>
	-->

						   <!--                                <div v-if="duoxinghao" style="position: relative;left: 60%">-->

						   <!--                                    <el-input v-model="duoxinghaocesuan.toString()" placeholder="" style="width: 20%;" disabled="disabled"></el-input>-->
						   <!--                                    <el-button type="primary" @click="duoxinghaotijiao" style="margin-top:-20px">提交测算</el-button>-->

						   <!--                                </div>-->

					   </el-form>
					<div v-if="!shenpiyemian">
					    <div v-if="shengchengflag"
					         style="width: 100%;display: flex;justify-content: center;align-items: center;margin-top: 0.2rem;">
					        <div style="padding: 0.1rem 0.25rem;border-radius: 0.05rem;background: #2686e7;color: #fff;font-size: 0.16rem;text-align: center;cursor: pointer;"
					             @click="danxinghao">生成
					        </div>
					    </div>
					    <div v-else
					         style="width: 100%;display: flex;justify-content: center;align-items: center;margin-top: 0.2rem;">
					        <div style="padding: 0.1rem 0.25rem;border-radius: 0.05rem;background: #2686e7;color: #fff;font-size: 0.16rem;text-align: center;cursor: pointer;"
					             @click="duoxinghaotijiao">生成
					        </div>
					    </div>
					</div>
					<el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible1" class="h-dialog2">
					    <div class="h-dialogImg">
					        <div class="h-disTable">
					            <div class="h-tableCell">
					                <h1>新增测算型号</h1>
					                <p>New Calculation Model</p>
					            </div>
					        </div>
					    </div>
					    <div class="h-formLines tan">
					        <div>
					            <el-form :model="form" label-position=right ref="form" :inline="true"
					                     class="demo-ruleForm h-formbLine">
					                <el-form-item label="大类" class="h-elformWrap-2" prop="dalei" :rules="[
									        { required: true, message: '必须输入选项', trigger: 'blur'}]"
					                              v-if="!shenpiyemian&&!beibohui" style="width: 50%!important;">
					                    <el-select v-model="form.dalei" filterable @change="handleItemChange1"
					                               placeholder="大类">
					                        <el-option
					                                v-for="item in list1"
					                                :key="item.value"
					                                :label="item.levelname"
					                                :value="item.id">
					                        </el-option>
					                    </el-select>
					                </el-form-item>

					                <el-form-item label="物料" class="h-elformWrap-2" @change="changewuliao"
					                              v-if="!shenpiyemian&&!beibohui" style="width: 50%!important;">
					                    <el-select v-model="form.wuliao"
					                               filterable
					                               placeholder="物料">
					                        <el-option
					                                v-for="item in list2"
					                                :key="item.value"
                                                    :label="`[${item.materialCode}] ${item.materialDescrition}`"
					                                :value="item.materialCode">
					                        </el-option>
					                    </el-select>
					                </el-form-item>
					            </el-form>
					        </div>
					        <div style="display:flex;justify-content:center;padding-bottom:20px">
					            <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">取消</el-button>
					            <el-button class="h-btn h-formBtn h-bgblueQ2" @click="queren">确认</el-button>
					        </div>
					    </div>
					</el-dialog>




<!--                    <div class="xia" v-if="!shenpiyemian" style="margin-top: 0.3rem;">-->
<!--                        <el-button class="h-btn h-bBtn h-bgwhite" @click="qiehuanbanben">选择计算版本</el-button>-->
<!--                    </div>-->

                    <div class="anniu" v-if="guanliyuan" style="margin-top: 0.4rem;">
                        <el-button class="el-button h-btn h-bBtn h-bgblueQ2 el-button--default"
                                   @click="gongshiduizhaokai">公式对照表
                        </el-button>
                        <el-button class="el-button h-btn h-bBtn h-bgblueQ2 el-button--default"
                                   @click="xiangxixinxixianshi">显示详细计算信息
                        </el-button>
                        <el-button class="el-button h-btn h-bBtn h-bgred el-button--default" @click="kankanyichang">
                            异常信息
                        </el-button>
                    </div>


                </div>
            </div>
        </div>
        <div class="h-table ljjtableenterlkn">
            <el-table
                    :data="tableData"
                    :span-method="objectSpanMethod"
                    @cell-dblclick="dblclick"
                    border
					max-height="500"
                    style="width: 100%; margin-top: 20px"
                    :row-class-name="tableRowClassName"

            >
                <el-table-column
                        prop="message"
                        label="分类"
						width="140"
                        :show-overflow-tooltip="true"
                        fixed
                >
                </el-table-column>
                <el-table-column
                        prop="coding"
						width="190"
                        :show-overflow-tooltip="true"
                        label="科目"
						fixed
                >
                </el-table-column>
                <el-table-column
                        prop="shuoming"
                        label="说明"
						min-width="200"
                        :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                        prop="biaozhun"
						:show-overflow-tooltip="true"
						width="120"
                        label="标准/单台">
                </el-table-column>
                <el-table-column
                        prop="hejiL"
						:show-overflow-tooltip="true"
						width="140"
                        label="合计-率">
						<template slot-scope="scope">
							<div v-if="scope.row.hejiL == '-'">{{scope.row.hejiL}}
							</div>
							<div v-else-if="scope.$index==3||scope.$index==2||scope.$index==1||scope.$index==0">{{scope.row.hejiL}}
							</div>

							<div v-else :title="scope.row.hejiL">{{new big(Number(scope.row.hejiL).toFixed(2)).times('100') + '%'}}</div>
						</template>
                </el-table-column>
                <el-table-column
                        prop="hejiE"
						:show-overflow-tooltip="true"
						width="140"
                        label="合计-额">
						<template slot-scope="scope">
							<div v-if="scope.$index==5||scope.$index==7||scope.$index==19||scope.$index==39||scope.$index==45" :title="scope.row.hejiE">{{new big(Number(scope.row.hejiE).toFixed(2)).times('100') + '%'}}
							</div>
							<div v-else-if="scope.$index==3||scope.$index==2||scope.$index==1||scope.$index==0">{{scope.row.hejiE}}
							</div>
							<div v-else :title="scope.row.hejiE">{{Number(scope.row.hejiE).toFixed(2)}}
							</div>
						  <!--  <div v-if="scope.$index>3" :title="scope.row.hejiE">{{Math.round(scope.row.hejiE * 100) /
						        100}}
						    </div> -->
						</template>
                </el-table-column>
                <el-table-column
                        :prop="item.prop"
						min-width="150"
                        :label="item.label" v-for="item in columndata" :key='item.label'>

                    <!--						<template slot-scope="scope">-->
                    <!--                            <div v-if="scope.row">{{scope.row[item.prop]}}</div>-->
                    <!--							<el-input v-model="scope.row[item.prop]" v-else></el-input>-->
                    <!--						</template>-->
                    <template slot-scope="scope">
                        <el-input class="h-tableInput"
                                v-if="scope.$index == 4 ||scope.$index == 8 ||scope.$index == 6||scope.$index == 9 || scope.$index == 16 || scope.$index == 21 || scope.$index ==30"
                                v-model="scope.row[item.prop]"></el-input>
                        <!--                        <el-select v-model="scope.row[item.prop]" filterable placeholder="请选择" v-if="scope.$index == 0">-->
                        <!--                            <el-option-->
                        <!--                                    v-for="item in xinghaoliebiao"-->
                        <!--                                    :key="item.value"-->
                        <!--                                    :label="item.label"-->
                        <!--                                    :value="item.value">-->
                        <!--                            </el-option>-->
                        <!--                        </el-select>-->
                        <div v-else>
							<div v-if="scope.$index==5||scope.$index==7||scope.$index==19||scope.$index==39||scope.$index==45" :title="scope.row[item.prop]">{{new big(Number(scope.row[item.prop]).toFixed(2)).times('100') + '%'}}
							</div>
							<div v-else-if="scope.$index==3||scope.$index==2||scope.$index==1||scope.$index==0">{{scope.row[item.prop]}}
							</div>
							<div v-else :title="scope.row[item.prop]">{{Number(scope.row[item.prop]).toFixed(2)}}
							</div>
                           <!-- <div v-if="scope.$index > 3" :title="scope.row[item.prop]">
                                {{Math.round(scope.row[item.prop] * 100) / 100 + ''}}
                            </div>
                            <div v-else>{{scope.row[item.prop]+ ''}}</div> -->
                        </div>
                    </template>
                </el-table-column>
                <!--            <el-table-column-->
                <!--                    prop="xiugai"-->
                <!--                    label="修改"-->
                <!--            >-->
                <!--                <template slot-scope="scope">-->
                <!--                    <div style="display:flex">-->
                <!--                        <el-select v-model="changeelse" placeholder="请选择" @change="elsechangetype">-->
                <!--                            <el-option v-for="item in changeelseOptions" :key="item.value"-->
                <!--                                       :label="item.label" :value="item.value">-->
                <!--                            </el-option>-->
                <!--                        </el-select>-->
                <!--                        <el-input v-model="scope.row.xiugai" placeholder="请输入"></el-input>-->
                <!--                        <el-button-->
                <!--                                type="text"-->
                <!--                                size="small"-->
                <!--                                class="h-tableLink"-->
                <!--                                @click="changetogo(scope.row.xiugai)">-->
                <!--                            修改-->
                <!--                        </el-button>-->
                <!--                    </div>-->
                <!--                </template>-->
                <!--            </el-table-column>-->

            </el-table>
            <div class="h-tableB h-mrt30">
                <!--                <div class="h-pagination2 ">-->
                <!--                    <paginationminNosize :page="q" @query="query"/>-->
                <!--                </div>-->
            </div>
        </div>
        <!--        <div class="drags" style="width:96.5%;padding:0 38px;margin-left:21px;margin-top:-20px;">-->
        <!--            <el-slider v-model="value3" :show-tooltip="true" :show-stops="true" @change="gotonextpage"></el-slider>-->
        <!--        </div>-->
        <!--        <div class="xia">-->
        <!--            <el-row>-->
        <!--                <el-button class=" zancun" style="width:100px;" @click="getconfigs(1)">计算</el-button>-->
        <!--                <el-button style="background-color:rgb(39, 122, 190);color:white; width:130px;" @click="gotosubmitok">-->
        <!--                    确认提交-->
        <!--                </el-button>-->
        <!--                <el-button class=" zancun" style="width:100px;  ">暂存</el-button>-->
        <!--                <el-button style="width:90px;">取消</el-button>-->
        <!--            </el-row>-->
        <!--        </div>-->

        <div class="yx_progressBar" v-if="xianshinage==0">
            <div class="yxExtra">
                <div style="margin-bottom: 0.2rem;">该申请价格达到盈利目标</div>
            </div>
            <div class="yx_topTip">
                <div class="leftdes">
                    <span>材料毛利：</span><span class="percent">{{zongmaolilv}}%</span>
                </div>
                <div class="leftdes">
                    <span>经营贡献：</span><span class="percent">{{jingyinggongxiangzong!=null&&jingyinggongxiangzong!=''&&jingyinggongxiangzong!=0?(parseFloat(jingyinggongxiangzong)).toFixed(2):0}}</span>
                </div>

                <div class="leftdes">
                    <span>经营贡献率：</span><span class="percent">{{this.tableData&&this.tableData.length>0?this.tableData[39].hejiE==null||this.tableData[39].hejiE==''?0:((parseFloat(this.tableData[39].hejiE)*100).toFixed(2)):0}}%</span>
                </div>
                <div class="leftdes">
                    <span>利润：</span><span class="percent">{{lirunzong!=null&&lirunzong!=''&&lirunzong!=0?(parseFloat(lirunzong)).toFixed(2):0}}</span>
                </div>

                <div class="leftdes">
                    <span>利润率：</span><span class="percent">{{this.tableData&&this.tableData.length>0?this.tableData[45].hejiE==null||this.tableData[45].hejiE==''?0:((parseFloat(this.tableData[45].hejiE)*100).toFixed(2)):0}}%</span>
                </div>


            </div>

            <!--			<div class="con_progress">-->
            <!--				<div class="eve_proout" v-for="(item,i) in progressBar" :key="i">-->
            <!--					<div class="eve_pro">-->
            <!--						<div class="persons">{{item.name}}</div>-->
            <!--					</div>-->
            <!--					<div class="line_pro"></div>-->
            <!--				</div>-->
            <!--			</div>-->

        </div>


        <div style="margin:20px" v-else>
            <div class="yx_progressBar yx_progressBarAc">
                <div class="yxExtra" style="right: 2.5rem;top: 0.4rem">
                    <div style="margin-bottom: 0.2rem;"></div>

                </div>
                <!--                <el-button class="h-btn h-bgblueQ2" @click="tijiaoshenqingtejia" style="position:absolute;top:0.3rem;right: 0.7rem">发起特价申请</el-button>-->
                <div class="yx_topTip">
                    <div class="leftdes">
                        <span>材料毛利：</span><span class="percent">{{zongmaolilv}}%</span>
                    </div>

                    <div class="leftdes">
                        <span>经营贡献：</span><span class="percent">{{jingyinggongxiangzong!=null&&jingyinggongxiangzong!=''&&jingyinggongxiangzong!=0?(parseFloat(jingyinggongxiangzong)).toFixed(2):0}}</span>
                    </div>

                    <div class="leftdes">
                        <span>经营贡献率：</span><span class="percent">{{this.tableData&&this.tableData.length>0?this.tableData[39].hejiE==null||this.tableData[39].hejiE==''?0:((parseFloat(this.tableData[39].hejiE)*100).toFixed(2)):0}}%</span>
                    </div>
                    <div class="leftdes">
                        <span>利润：</span><span class="percent">{{lirunzong!=null&&lirunzong!=''&&lirunzong!=0?(parseFloat(lirunzong)).toFixed(2):0}}</span>
                    </div>

                    <div class="leftdes">
                        <span>利润率：</span><span class="percent">{{this.tableData&&this.tableData.length>0?this.tableData[45].hejiE==null||this.tableData[45].hejiE==''?0:((parseFloat(this.tableData[45].hejiE)*100).toFixed(2)):0}}%</span>
                    </div>


                </div>
                <!--            <div class="con_progress">-->
                <!--                <div class="eve_proout" v-for="(item,i) in progressBar" :key="i">-->
                <!--                    <div class="eve_pro" :class="{eve_proAc:item.ifBlue==1,eve_proAcpass:item.ifBlue ==2}">-->
                <!--                        <div class="persons" :class="{personsAc:item.ifBlue==1}">{{item.name}}</div>-->
                <!--                    </div>-->
                <!--                    <div class="line_pro" :class="{line_proAc:item.ifBlue==1,line_proAcpass:item.ifBlue == 2}"></div>-->
                <!--                </div>-->
                <!--            </div>-->
            </div>
        </div>
        <div class="xia">
           <!-- <el-button class="h-btn h-bBtn h-bgwhite" @click="handleDelete">删除版本</el-button>-->
            <el-button class="h-btn h-bBtn h-bgwhite" @click="fanhuishangye">返回</el-button>

   <!--          <el-button class="h-btn h-bBtn h-bggreen"
                       @click="jisuanpanduan('zancun')" v-if="!beibohui && !shenpiyemian">暂存
            </el-button> -->

            <el-button class="h-btn h-bBtn h-bggreen"
                       @click="jisuanpanduan(1)">计算
            </el-button>

            <el-button class="h-btn h-bBtn h-bgblue2"
                       @click="jisuanpanduan('tijiao')" v-if="!beibohui && !shenpiyemian">
                确认提交
            </el-button>

            <el-button class="h-btn h-bBtn h-bgblue2"
                       @click="jisuanpanduan('chongxintijiao')" v-if="shenpiyemian && chongxinfaqi">
                重新提交
            </el-button>

        </div>

        <!-- 选择测算版本 -->
        <el-dialog :close-on-click-modal="false" :visible.sync="refuseDialog" class="h-dialog2" @close="gettable">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>选择以往测算版本</h1>
                        <p>Selection process</p>
                    </div>
                </div>
            </div>


            <div class="h-formLines">
                <div style="padding: 40px;">

                    <el-select v-model="banbenid" placeholder="请选择" style="width:7rem;" @change="fuzhi">
                        <el-option v-for="item in banbenop" :key="item.value"
                                   :label="item.label" :value="item.value">
                        </el-option>

                    </el-select>

                    <div style="text-align: right;margin-top: 5%">
                        <el-button class="h-btn h-formBtn" style="" @click="refuseDialog=false">确定</el-button>
                    </div>

                </div>

            </div>


        </el-dialog>


        <!-- 计算详细记录 -->
        <el-dialog :visible.sync="xiangxijilu" :show-close="true" :close-on-click-modal="false">

            <div>

                <el-input type="textarea" v-model="xiangxijilujieguo" readonly rows="50"></el-input>

            </div>

            <div style="text-align: right;margin-top: 5%">
                <el-button class="h-btn h-formBtn" style="" @click="xiangxijilu=false">确定</el-button>
            </div>


        </el-dialog>


        <!-- 公式对照表 -->
        <el-dialog :visible.sync="gongshiduizhao" :show-close="true" :close-on-click-modal="false">

            <div>

                <el-input type="textarea" v-model="gongshiduizhaobiao" readonly rows="50"></el-input>

            </div>

            <div style="text-align: right;margin-top: 5%">
                <el-button class="h-btn h-formBtn" style="" @click="gongshiduizhao=false">确定</el-button>
            </div>


        </el-dialog>


        <!-- 异常信息 -->
        <el-dialog :visible.sync="jianchayichang" :show-close="true" :close-on-click-modal="false">

            <div>

                <el-input type="textarea" v-model="yichangxinxi" readonly
                          rows="50"></el-input>

            </div>

            <div style="text-align: right;margin-top: 5%">
                <el-button class="h-btn h-formBtn" style="" @click="jianchayichang=false">确定</el-button>
            </div>


        </el-dialog>


        <!--地址信息-->
     <!--    <areaSelect
                :visible.sync="showdizhiflag"
                v-if="showdizhiflag"
                @choseObj="choseDizhi"
        /> -->

    </div>
</template>
<style scoped lang="scss">
    $ft-colorg: #21d16f; //绿色的字
    $ft-coloro: #e79118; //黄色的字
    $bg-colorg: #f6fffa; //绿色的背景色
    $bg-coloro: #fffbf7; //黄色的背景色
    $bg-colorb: #3b77fc; //蓝色
    $bg-colorgrey: #c3c3c3; //灰色
    .yx_progressBar {
        margin: 0.28rem 0;
        width: 100%;
        border: 1px solid $ft-colorg;
        background-color: $bg-colorg;
        padding: 0.38rem;
        position: relative;

        .yxExtra {
            position: absolute;
            color: $ft-colorg;
            top: 0.3rem;
            font-size: 0.18rem;
            right: 0.3rem;
        }

        .yx_topTip {
            display: flex;
            justify-content: flex-start;
            color: #424441;
            font-size: 0.18rem;

            .leftdes {
                margin-right: 0.75rem;
            }

            .percent {
                color: $ft-colorg;
            }
        }

        .con_progress {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-top: 0.3rem;

            .eve_proout {
                display: flex;
                align-items: center;
                justify-content: flex-start;

                &:last-child .line_pro {
                    display: none;
                }

                .eve_pro {
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    position: relative;
                    background-color: $bg-colorgrey;

                    .persons {
                        position: absolute;
                        top: 20px;
                        min-width: 1.8rem;
                        text-align: center;
                        margin-left: -0.75rem;
                        margin-top: 0.04rem;
                        font-size: 0.18rem;
                    }

                    .personsAc {
                        color: $bg-colorb;
                    }
                }


                .line_pro {
                    width: 3rem;
                    height: 4px;
                    background-color: $bg-colorgrey;
                }

                // 激活
                .eve_proAc {
                    background-color: $bg-colorb;
                }

                .line_proAc {
                    width: 3rem;
                    height: 4px;
                    background-color: $bg-colorb;
                }

                .eve_proAcpass {
                    background-color: $bg-colorgrey;
                }

                .line_proAcpass {
                    width: 3rem;
                    height: 4px;
                    background-color: $bg-colorb;
                }
            }

        }
    }

    .yx_progressBarAc {
        border: 1px solid $ft-coloro;
        background-color: $bg-coloro;

        .yxExtra {
            color: $ft-coloro;
        }

        .yx_topTip {
            .percent {
                color: $ft-coloro;
            }
        }
    }


    .zancun {
        background-color: #24b5b8;
        color: white;
    }

    // .product {
    //     margin-top: 10px;

    // }

    // .Ptitle {
    //     margin-top: 30px;
    // }
    // .resultA {
    //     border: 1px solid rgb(104, 184, 108);
    //     background-color: rgb(224, 233, 224);
    //     color: rgb(126, 216, 130);
    // }

    // .resultA, .resultB {
    //     width: 100%;
    //     height: 150px;
    //     border-radius: 4px;
    //     margin: 20px 0;
    // }

    // .resultB {
    //     border: 1px solid rgba(233, 161, 52, 0.925);
    // }

    h6 > span {
        color: greenyellow;
    }

    h6 > .span {
        color: rgba(233, 161, 52, 0.925);
    }

    .xia {
        justify-content: center;
        display: flex
    }
</style>

<script>
    import showxuanzerencesuan from '../../../components/dialog/selectshdfcesuan'
    import ss from '../../../api/SystemService'
    import big from 'big.js'

    export default {

        components: {
            showxuanzerencesuan
        },


        data() {

            return {

                cesuanid:'',

                shenpiyijianshow: false,

                dailishangsuoding:false,

				showOrhide:false,
				status:1,
				checked:true,
				toshow:"enterfour",
				wuliaolist: [],
				shengchengflag: true,
				wuliaotext: '',
				dialogFormVisible1: false,
                zhiqianbanben: {},

                meiyoubanben: false,

                yichangxinxi: '',

                jianchayichang: false,

                showdizhiflag: false,

                gongshiduizhaobiao: '',

                gongshiduizhao: false,

                guanliyuan: false,

                xiangxijilu: false,

                xiangxijilujieguo: '',

                songdachengshilist: [],

                //销售经理
                shifouxiaoshoujingli: false,

                //guoneiquyulist: [],


                xuanzeren: false,


                daishanchubanben: '',

                shenpiyemian: false,
                chongxinfaqi:false,

                guochenglist: [],

                banbenid: '',


                banbenop: [],


                rversion: '',

                refuseDialog: false,

                //被驳回
                beibohui: false,

                duoxinghao: false,


                list1: [],

                list2: [],

                form: {

                    dalei: '',
                    wuliao: '',

                },

                queryq: {
                    pcode: 0,
                    oneLid: '',
                },


                //显示哪个利率总计框
                xianshinage: 9,

                jingyinggongxiangzong: 0,

                lirunzong: 0,

                zongmaolilvbiao: 0,

                zongmaolilv: 0,


                // 进度
                progressBar: [
                    {name: "王振刚", ifBlue: 1, ifing: 0},
                    {name: "总部管理员", ifBlue: 1, ifing: 0},
                    {name: "财务经理", ifBlue: 2, ifing: 0},
                    {name: "待审核", ifBlue: 0, ifing: 0},
                ],

                list: [
                    {
                        title: '提交人:王振刚',
                        isactive: 0,
                        time: '2019/09/10 18:00:00',
                    },
                    {
                        title: '总部管理员',
                        isactive: 0,
                        time: '2019/09/10 18:00:00',
                    },
                    {
                        title: '待审核',
                        isactive: 0,
                        time: '2019/09/10 18:00:00',
                    },
                    {
                        title: '财务经理',
                        isactive: 0,
                        time: '2019/09/10 18:00:00',
                    }
                ],


                //物料号
                marcode: '',

                showflag: true,


                //型号列表
                xinghaoliebiao: [],


                rules: {
                    bidway: [
                        {required: true, message: '不能为空', trigger: 'blur'},
                    ],

                    repairtype: [
                        {required: true, message: '不能为空', trigger: 'blur'},
                    ],

                    pdpay: [
                        {required: true, message: '不能为空', trigger: 'blur'},
                    ],

                    fdpay: [
                        {required: true, message: '不能为空', trigger: 'blur'},
                    ],

                    mdpay: [
                        {required: true, message: '不能为空', trigger: 'blur'},
                    ],

                    ldpay: [
                        {required: true, message: '不能为空', trigger: 'blur'},
                    ],

                    fdpayday: [
                        {required: true, message: '不能为空', trigger: 'blur'},
                    ],

                    mdpayday: [
                        {required: true, message: '不能为空', trigger: 'blur'},
                    ],

                    ldpayday: [
                        {required: true, message: '不能为空', trigger: 'blur'},
                    ],


                },


                //项目产品list
                xiangmuchanpinlist: [],


                q: {

                    pageSize: 5,
                    pageNo: 1,
                    total: 0,

                },

                //全合计金额map
                allratemap: {},


                //是否首次交互
                shoucijiaohu: true,

                //申请单价含税 组
                shenqingdanjiaop: [],

                //附加成本 组
                fujiachengbenop: [],

                //中标服务费 组
                zhongbiaofuwufei: [],

                //中标服务费
                zhongbiaofuwufei: "",

                //附加成本
                fujiachengben: "",

                //申请单价含税
                shenqingdanjia: '',

                //项目编号
                proid: "zckceshi",

                //质保选中值
                repairtype: '正常质保',

                repairOptions: [{
                    value: '正常质保',
                    label: '正常质保'
                }, {
                    value: '五年质保',
                    label: '五年质保'
                }],
                //
                columndata: [],

                //列表翻页参数
                value3: 0,

                duoxinghaocesuan: [],

                //上部列表信息
                ProMain: {

                    //选中人
                    //xuanzhongren: '',
                    //使用人
                    //shiyongren: '',

                    //有效期开始时间
                    youxiaoqistart:'',
                    youxiaoqi: '',

                    shenpiyijian: '',

                    //送达地址
                    //songdadizhi: '',

                    //送达城市
                    //songdachengshi: '',

                    //quyu: '',

                    //项目名称
                    projectName: '',

                    //投标方式
                    bidway: '',

                    //开标日期
                    bid: '',

                    //预付百分比
                    pdpay: '',

                    //首款百分比
                    fdpay: '',

                    //中款百分比
                    mdpay: '',

                    //尾款百分比
                    ldpay: '',

                    //首款天
                    fdpayday: '',

                    //中款天
                    mdpayday: '',

                    //尾款天
                    ldpayday: '',

                    //项目描述
                    projectDescription: '',

                    //终端成交价
                    zhongduanchengjiaojia: '',

                    //专营商毛利率
                    zhuanyingshangmaolilv: '',

                },


                //当前表信息
                tableData: [],


                //所有查到的计算回调信息
                alllastlist: [],


            };
        },

        //加载页面默认执行
        created() {
			// 遮罩
			this.showzhezhao()
            //查找版本
            this.chazhaocesuan();

            //管理员
            this.guanliyuan = this.$store.getters.hasRole('swyl_admin');

            this.jiazaigongshibiao();

            //this.getsongdachengshilist();

            //判断目前使用人如果是销售经理，就会默认隐藏表格一部分
            for (var d in this._user.roles) {

                if (this._user.roles[d].id == 'swyl_xiaoshoujl' || this._user.roles[d].id == 'swyl_xiaoshoujl_wx' || this._user.roles[d].id == 'xiaoshoujingli-waixiao' || this._user.roles[d].id == 'zidonghualengku') {

                    this.shifouxiaoshoujingli = true;

                }

            }


            //this.guoneiquyulist = this.$store.getters.dictlist("guoneiquyu_cesuan");

            this.loadArea(1);


            //若是有转发信息
            // if (this.$route.query != null) {
                if(JSON.stringify(this.$route.query) != '{}'){

                //若是审批信息
                if (this.$route.query.ywid) {

                    console.log(this.$route.query, '看看审批的对象')

                    //ywid
                    this.ywid = this.$route.query.ywid;

                    //instid
                    this.instid = this.$route.query.instid;

                    //taskid
                    this.taskid = this.$route.query.taskid;

                    //计算版本
                    this.rversion = this.$route.query.ywid;

                    //待删除版本
                    this.daishanchubanben = this.$route.query.ywid;
                     //taskstatus
                    this.taskstatus = this.$route.query.taskstatus;

                    if(this.taskstatus==0) {
                        this.chongxinfaqi = true;
                    }else {
                        this.chongxinfaqi = false;
                    }
                    //是审批页面
                    this.shenpiyemian = true;

                    this.shoucijiaohu = true;
                    this.banbenid = '';
                    this.banbenop = [];

                    //加载对应历史记录版本
                    this.zaijiajisuanjilu(this.$route.query.ywid);


                }


            }

        },

        mounted() {

        },
        methods: {

            //查找财务单保存
            chazhaocaiwudanbaocun(q){

                ss.FormulaNew.finddanbaocun(q).then(rd => {

                    console.log(rd,'rdrdrdrdoooooo')

                    if(JSON.stringify(rd.obj) != '{}' && rd.obj.rversion!=null && rd.obj.rversion!=''){

                        this.cesuanid = rd.obj.rversion;

                        this.shenpiyijianshow = true;

                    }

                })


            },

            //测算版本查看
            cesuanbanbenchakan() {

                //测算版本有的话
                if(this.cesuanid!=null && this.cesuanid!=''){

                    var rversion = {

                        rversion:this.cesuanid
                    }

                    //查找测算版本
                    ss.FormulaNew.getbanben(rversion).then(rd => {

                        console.log(rd.obj,'测算')

                        //测算
                        this.neiwaixiaopanduan(rd.obj);

                    })

                }

            },

            //测算跳转判断
            neiwaixiaopanduan(q){
                console.log(q, "asdasd????")

                var path = '';

                if (q.neixiaowaixiao == 1 && q.ispro==1) { //外销项目
                    //跳转外销项目
                    path = '/xiangmu/entersix';

                } else if (q.neixiaowaixiao == 1 && q.ispro==0) { //外销工具
                    //跳转外销工具
                    path = '/xiangmu/enterseven';

                }else if (q.neixiaowaixiao == 0) { //内销
                    //跳转内销测算
                    path = '/xiangmu/enterfive';

                } else if (q.neixiaowaixiao == 2) { //租赁
                    //跳转内销测算
                    path = '/rateFormulaZulinshiti';

                }

                var shiti = {
                    chakanshiti:q.rversion
                }

                console.log(shiti,'shitishitishiti')


                let routeData = this.$router.resolve({ path: path, query: shiti });
                window.open(routeData.href, '_blank');


            },


            toubiaochange(v){

                if(v && v.code=='经销商'){

                    console.log(v,'v')

                    this.ProMain.pdpay = 1;
                    this.ProMain.fdpay = 0;
                    this.ProMain.mdpay = 0;
                    this.ProMain.ldpay = 0;
                    this.ProMain.fdpayday = 0;
                    this.ProMain.mdpayday = 0;
                    this.ProMain.ldpayday = 0;

                    this.dailishangsuoding = true;

                }else{

                    this.ProMain.pdpay = '';
                    this.ProMain.fdpay = '';
                    this.ProMain.mdpay = '';
                    this.ProMain.ldpay = '';
                    this.ProMain.fdpayday = '';
                    this.ProMain.mdpayday = '';
                    this.ProMain.ldpayday = '';

                    this.dailishangsuoding = false;

                }

            },

			showzhezhao(){
				ss.salesList.toshow(this.toshow).then(rd => {
					console.log(rd)
				    if(rd == false){
				        this.showOrhide = false;
				    }else{
				        this.showOrhide = true;
						document.documentElement.scrollTop = 1000
				    }
				})
			},
			ldpaychange(v){
				console.log(v)
				if(v==0){
					return
				}else{
					if(/^0.\d+$/.test(v) == false){
						this.$msg.msge('请输入小于1的小数')
						this.ProMain.ldpay = ''
					}else{
						if(this.ProMain.ldpay && this.ProMain.mdpay && this.ProMain.fdpay && this.ProMain.pdpay){
							if ((parseFloat(this.ProMain.pdpay) + parseFloat(this.ProMain.fdpay) + parseFloat(this.ProMain.mdpay) + parseFloat(this.ProMain.ldpay)).toFixed(2) != 1) {
								this.$msg.msge("四个百分值小数相加必须等于100%")
								this.ProMain.pdpay = '';
								this.ProMain.fdpay = '';
								this.ProMain.ldpay = '';
								this.ProMain.mdpay = '';
							}else{
								return
							}
						}
						console.log(v)
						return
					}
				}
			},
			mdpaychange(v){
				console.log(v)
				if(v==0){
					return
				}else{
					if(/^0.\d+$/.test(v) == false){
						this.$msg.msge('请输入小于1的小数')
						this.ProMain.mdpay = ''
					}else{
						if(this.ProMain.ldpay && this.ProMain.mdpay && this.ProMain.fdpay && this.ProMain.pdpay){
							if ((parseFloat(this.ProMain.pdpay) + parseFloat(this.ProMain.fdpay) + parseFloat(this.ProMain.mdpay) + parseFloat(this.ProMain.ldpay)).toFixed(2) != 1) {
								this.$msg.msge("四个百分值小数相加必须等于100%")
								this.ProMain.pdpay = '';
								this.ProMain.fdpay = '';
								this.ProMain.ldpay = '';
								this.ProMain.mdpay = '';
							}else{
								return
							}
						}
						console.log(v)
						return
					}
				}
			},
			fdpaychange(v){
				console.log(v)
				if(v==0){
					return
				}else{
					if(/^0.\d+$/.test(v) == false){
						this.$msg.msge('请输入小于1的小数')
						this.ProMain.fdpay = ''
					}else{
						if(this.ProMain.ldpay && this.ProMain.mdpay && this.ProMain.fdpay && this.ProMain.pdpay){
							if ((parseFloat(this.ProMain.pdpay) + parseFloat(this.ProMain.fdpay) + parseFloat(this.ProMain.mdpay) + parseFloat(this.ProMain.ldpay)).toFixed(2) != 1) {
								this.$msg.msge("四个百分值小数相加必须等于100%")
								this.ProMain.pdpay = '';
								this.ProMain.fdpay = '';
								this.ProMain.ldpay = '';
								this.ProMain.mdpay = '';
							}else{
								return
							}
						}
						console.log(v)
						return
					}
				}

			},
			pdpaychange(v){
				console.log(v)
				if(v == 1){
					this.ProMain.pdpay = 1;
					this.ProMain.fdpay = 0;
					this.ProMain.mdpay = 0;
					this.ProMain.ldpay = 0;
				}else{
					this.ProMain.fdpay = '';
					this.ProMain.mdpay = '';
					this.ProMain.ldpay = '';
					if(/^0.\d+$/.test(v) == false){
						this.$msg.msge('请输入小于1的小数')
						this.ProMain.pdpay = ''
					}else{
						console.log(v)
						return
					}
				}

			},


			// 取消物料弹窗
			cancel() {
			    this.f = {}
			    this.dialogFormVisible1 = false;
			},
			// 删除物料号
			delwuliao(c) {
			    var ins = this.duoxinghaocesuan.indexOf(c)
			    this.duoxinghaocesuan.splice(ins, 1);
			},
			// 某一条物料编码
			changewuliao(v) {
			    this.wuliaotext = v;
			},
			// 添加按钮
			adds() {
			    this.dialogFormVisible1 = true;
			},
			// 确认物料
			queren() {
				if(this.form.dalei && this.form.wuliao){
					this.zhuijiaxinghao()
					this.dialogFormVisible1 = false;
					if (this.duoxinghaocesuan.length == 0) {
					    this.shengchengflag = true
					} else if (this.duoxinghaocesuan.length > 1) {
					    this.shengchengflag = false
					}
				}else{
					this.$msg.msge("请选择大类和物料再进行确认")
				}

			},


            chazhaocesuan() {

                var pid = {

                    neixiaowaixiao: 0,

                }

                ss.FormulaNew.findguocheng(pid).then(rd => {

                    console.log(rd, 'a')


                    if (JSON.stringify(rd.obj) == '{}') {

                        this.meiyoubanben = true;


                    } else {

                        this.meiyoubanben = false;

                        this.zhiqianbanben = rd.obj;

                    }


                })


            },

            kankanyichang() {

                this.jianchayichang = true;

            },

            //选择地址
            // selectAreadialog() {
            //     this.showdizhiflag = true;
            // },

            // choseDizhi(obj) {

            //     console.log(obj, 'objsss')

            //     console.log(obj.quobj.pscode + "_" + obj.quobj.name, 'o222ss')

            //     this.ProMain.songdachengshi = obj.quobj.pscode ? (obj.quobj.pscode + "_" + obj.quobj.name) : obj.shiobj.pscode ? (obj.shiobj.pscode + "_" + obj.shiobj.name) : null;

            //     this.ProMain.songdadizhi = obj.quobj.namepath;

            //     if (obj.zhenobj) {

            //         this.ProMain.songdadizhi = obj.zhenobj.namepath;

            //     }

            //     this.ProMain.songdadizhi = this.ProMain.songdadizhi + obj.addrdetail;

            //     // this.zy.province = obj.shengobj.name;
            //     // this.zy.city = obj.shiobj.name;
            //     // this.zy.country= obj.quobj.name;

            //     this.showdizhiflag = false;
            // },


            jiazaigongshibiao() {

                ss.FormulaNew.gongshibiaolist().then(rd1 => {

                    this.gongshiduizhaobiao = '';

                    for (var c in rd1) {

                        if (rd1[c].type != 'w' && rd1[c].type != 'u') {

                            this.gongshiduizhaobiao += ("公式名: " + rd1[c].proName + (rd1[c].modelName != null && rd1[c].modelName != '' ? ("/" + rd1[c].modelName) : '') + (rd1[c].ratetext != null && rd1[c].ratetext != '' ? (" || 公式信息: " + rd1[c].ratetext) : "") + " || 公式编号: " + rd1[c].formulanum + (rd1[c].formula != null && rd1[c].formula != '' ? (" || 公式: " + rd1[c].formula) : '') + '\n' + '\n');

                        }

                    }

                })


            },


            gongshiduizhaokai() {

                this.gongshiduizhao = true;

            },

            xiangxixinxixianshi() {

                this.xiangxijilu = true;

            },

            jiazaijieguoxinxi(rd) {

                this.xiangxijilujieguo = '';

                this.yichangxinxi = '';

                for (var c in rd.jisuanjilu) {

                    this.xiangxijilujieguo += (c + rd.jisuanjilu[c] + '\n' + '\n');

                }

                this.yichangxinxi = rd.sb;

            },


            //获取送达城市
            // getsongdachengshilist() {

            //     ss.Dictservice.listbycategory("pscode_cesuan").then(rd => {

            //         this.songdachengshilist = rd;

            //     })

            // },


            tableRowClassName(row, index) {

                //若是销售经理
                if (this.shifouxiaoshoujingli) {

                    if (
                        row.rowIndex != 0 &&
                        row.rowIndex != 1 &&
                        row.rowIndex != 2 &&
                        row.rowIndex != 3 &&
                        row.rowIndex != 4 &&
                        row.rowIndex != 6 &&
                        row.rowIndex != 8 &&
                        row.rowIndex != 9 &&
                        row.rowIndex != 11 &&
                        row.rowIndex != 12 &&
                        row.rowIndex != 21 &&
                        row.rowIndex != 30 && row.rowIndex!=16
                    ) {
                        return 'hidden-row';
                    }
                    return '';
                }

            },


            //选择使用人
            // shiyongrenxuanze(val) {
            //     console.log(val, '+++使用人')
            //     this.xuanzeren = false;
            //     //this.ProMain.xuanzhongren = val.username;
            //    // this.ProMain.shiyongren = val.usercode;

            // },

            // tanchuxuanzeren() {
            //     this.xuanzeren = true;
            //     // dialogFormVisible
            // },

            //逻辑删除版本
            handleDelete() {

                if (this.rversion) {

                    var id = {

                        id: this.rversion

                    }

                    this.shanchubanben(id);

                } else {
                    this.$msg.msge("未选择计算版本")
                }

            },

            //删除版本
            shanchubanben(q) {

                ss.FormulaNew.luojishanchu(q).then(rd => {

                    this.$msg.msgs(rd.msg)

                    this.qiehuanbanben();

                })

            },


            //清空物料框
            qingkonghuidiao() {

                this.duoxinghao = false;

                this.duoxinghaocesuan = [];

            },


            //关闭选择框加载数据
            gettable() {

                //若选了版本
                if (this.banbenid) {

                    //遍历版本选项
                    for (var d in this.banbenop) {

                        //找到对应版本id的项
                        if (this.banbenop[d].value == this.banbenid) {

                            //设置instid
                            this.instid = this.banbenop[d].instid;

                            console.log(this.banbenop[d].instid, '看看')

                        }

                    }

                    console.log(this.rversion, '看看计算版本')

                }

                //如果有版本
                if (this.rversion) {

                    //加载对应历史记录版本
                    this.zaijiajisuanjilu(this.rversion);

                }
                // else{//没版本
                //
                //     //初始化
                //     this.haiwaiquery();
                //
                // }


            },

            //加载历史计算记录
            zaijiajisuanjilu(q) {

                var rversion = {

                    rversion: q,

                }

                //调接口回调方法
                ss.FormulaNew.getjisuanjiluneixiao(rversion).then(rd => {

                    console.log(rd, '看看返回的信息')

                    //若是驳回有审批意见的
                    if (rd.rateFormulaRenewVer && rd.rateFormulaRenewVer.shenpijindu) {

                        this.ProMain.shenpiyijian = rd.rateFormulaRenewVer.shenpijindu.split("_").length == 3 ? rd.rateFormulaRenewVer.shenpijindu.split("_")[2] || '' : '';

                        //查找财务单保存
                        this.chazhaocaiwudanbaocun(rversion);

						this.shoucijiaohu = false;

                    }

                    //下部列表所有计算查询返回信息
                    var listrd = rd.marnesList;

                    var allrate = rd.allrate;

                    var tou = rd.tou;

                    console.log(allrate)

                    this.allratemap = rd.allrate;

                    this.duoxinghaocesuan = rd.marcode;

                    this.duoxinghao = true;

                    //加载头部
                    this.jiazaitou(tou);

                    //加载列
                    this.addbiaotilie(listrd, allrate);

                    this.shoucijiaohu = false;

                });

            },


            //加载头部
            jiazaitou(q) {

                //投标方式
                this.ProMain.bidway = q.bidway || '';

                //保修期
                this.repairtype = q.baoxiuqi || '';

                //预付百分比
                this.ProMain.pdpay = q.f28 || '';

                //首款百分比
                this.ProMain.fdpay = q.f6 || '';

                //中款百分比
                this.ProMain.mdpay = q.f27 || '';

                //尾款百分比
                this.ProMain.ldpay = q.f34 || '';

                //首款天数
                this.ProMain.fdpayday = q.f23 || '';

                //中款天数
                this.ProMain.mdpayday = q.f13 || '';

                //尾款天数
                this.ProMain.ldpayday = q.f30 || '';

                //区域
                //this.ProMain.quyu = q.quyu || '';

                //送达城市代码
                //this.ProMain.songdachengshi = q.songdachengshi || '';

                //送达地址
               // this.ProMain.songdadizhi = q.songdadizhi || '';


                //选中人
                //this.ProMain.xuanzhongren = q.xuanzhongren || '';

                //使用人
                //this.ProMain.shiyongren = q.shiyongren || '';

                //有效期
                 this.ProMain.youxiaoqi = q.youxiaoqi || '';
                this.ProMain.youxiaoqistart = q.youxiaoqistart || '';

            },


            //选择，将被选中存起来
            fuzhi() {

                console.log(this.banbenid, '看看选择的对不对')

                //计算版本  选中计算版本
                this.rversion = this.banbenid;

            },


            //切换计算版本
            qiehuanbanben() {

                if (this.meiyoubanben == true) {

                    this.$msg.msge("没有测算版本")

                } else {

                    this.shoucijiaohu = true;
                    this.banbenid = '';
                    this.banbenop = [];

                    //查找工具版记录
                    this.chazhaogongjubanjilu();

                }


            },

            //查找工具版记录
            chazhaogongjubanjilu() {

                //不传项目id就是工具版的非项目记录
                this.chazhaojisuanguocheng(null);

            },


            //查找计算记录
            chazhaojisuanguocheng(q) {

                var pid = {

                    proid: q,
                    neixiaowaixiao: 0,

                }

                ss.FormulaNew.findguocheng(pid).then(rd => {

                    //如果查不到历史记录
                    if (Object.keys(rd.obj).length === 0) {

                        this.refuseDialog = false;

                        // //初始化表
                        // this.haiwaiquery(q);

                    } else {//查到记录

                        var num = 0;

                        //遍历计算版本map
                        for (var i in rd.obj) {

                            //存计算版本
                            this.guochenglist.push(rd.obj[i])

                            console.log(i, '反正--------')

                            console.log(rd.obj[i], '---------反正')

                            console.log(i, 'i.rversion')


                            //加载计算版本下拉选
                            var d = {

                                instid: rd.obj[i].instid,
                                value: i,
                                label: '版本 ' + (num + 1) + ' 创建时间:' + this.$util.riQi(rd.obj[i].cdate),

                            }

                            console.log(d, 'dddddd??')

                            //计算版本选项
                            this.banbenop.push(d);

                            num++;

                        }

                        //弹出选框
                        this.refuseDialog = true;

                    }


                })


            },


            // choseObj(obj) {
            //
            //     //必须先选区域
            //     if (!this.ProMain.quyu) {
            //
            //         this.$msg.msge("请先选择区域")
            //
            //     }
            //
            //     else {
            //
            //         console.log(obj, '看看什么值')
            //         // this.showflag = false;
            //         this.marcode = obj.wuliao;
            //         this.getconfigs(0);
            //
            //     }
            //
            //
            // },

            //多型号加载
            duoxinghaotijiao() {

                if (this.duoxinghaocesuan.length > 0) {

                    //批量加载
                    this.piliangcesuan(0);

                } else {

                    this.msg.msge("请先选择要批量测算的物料")

                }

            },


            panduanxiaoshu(q) {

                var d = true;

                var m = true;

                for (var c in this.ProMain) {

                    if (d == true) {


                        if (c == 'pdpay' || c == 'fdpay' || c == 'mdpay' || c == 'ldpay') {

                            if (c == 'pdpay' && (this.ProMain[c] >= 1 || parseFloat(this.ProMain[c]) >= 1 || parseInt(this.ProMain[c]) >= 1)) {

                                d = true;
                                m = false;

                            } else {

                                if (m == true) {

                                    if (parseFloat(this.ProMain[c]) != 0 && (/^0.\d+$/.test(this.ProMain[c]) == false)) {

                                        if (q != 0) {

                                            this.$msg.msge("百分比请输入小于1的小数")

                                        }

                                        d = false;

                                    } else {

                                        d = true;

                                    }

                                }

                            }


                        }

                    }

                }


                if (d == true) {

                    if (this.ProMain.pdpay >= 1 || parseFloat(this.ProMain.pdpay) >= 1.0 || parseInt(this.ProMain.pdpay) >= 1) {

                        this.ProMain.pdpay = 1;
                        this.ProMain.fdpay = 0;
                        this.ProMain.mdpay = 0;
                        this.ProMain.ldpay = 0;

                    } else {

                        if ((parseFloat(this.ProMain.pdpay) + parseFloat(this.ProMain.fdpay) + parseFloat(this.ProMain.mdpay) + parseFloat(this.ProMain.ldpay)) != 1) {

                            d = false;

                            if (q != 0) {

                                this.$msg.msge("四个百分值小数相加必须等于100%")

                            }


                        }


                    }

                }


                return d;

            },


            //计算判断
            jisuanpanduan(q) {


                this.dierceng(q);

            },

            dierceng(q){

                var d = this.panduanxiaoshu(q);

                // if (q != 0 && (!this.ProMain.songdachengshi || !this.ProMain.songdadizhi)) {

                //     this.$msg.msge("请先补充送达信息")

                // } else {

                    if (q != 0 && d == false) {

                    } else {

                        this.qupanduan(q);

                    }

                //}

            },


            qupanduan(q) {

                //若有多型号测算
                if (this.duoxinghaocesuan.length > 0) {

                    //走批量测算
                    this.piliangcesuan(q);

                }

                // else {
                //
                //     //走单型号测算
                //     this.getconfigs(q);
                //
                // }

            },


            //批量测算
            piliangcesuan(q) {

                //必须先选区域
                // if (!this.ProMain.quyu) {

                //     this.$msg.msge("请先选择区域")

                // } else {

                    //测算参数
                    var inputto = {
                        islengku:"1",
                        inputtolist: this.gouzaocanshulist(q),

                    }

                    console.log(inputto, '看看入参')

                    //存在参数走测算
                    if (inputto.inputtolist) {

                        //测算
                        this.jisuan(inputto, q);

                    }


                //}

            },


            //构造批量参数
            gouzaocanshulist(q) {

                //若是提交的，需要先填完整信息
                if ((q == 'chongxintijiao' || q == 'zancun' || q == 'tijiao' || q == 1) && !(this.ProMain.bidway && this.ProMain.pdpay != null && this.ProMain.fdpay != null && this.ProMain.mdpay != null && this.ProMain.ldpay != null && this.ProMain.fdpayday != null && this.ProMain.mdpayday != null && this.ProMain.ldpayday != null && this.ProMain.youxiaoqistart && this.ProMain.youxiaoqi)) {

                    this.$msg.msge("请先填写完整信息")

                } else {

                    var inputtolist = [];

                    console.log(this.duoxinghaocesuan,'this.duoxinghaocesuan')

                    for (var d in this.duoxinghaocesuan) {

                        //构造参数 q 0加载信息   1计算     s物料所在列     marcode物料号
                        //返回RateFormulaRenewXiangmucanshu entity
                        inputtolist.push(this.gouzaocanshu(q, (parseInt(d) + 1), this.duoxinghaocesuan[d]))

                    }

                    return inputtolist;

                }

            },


            //单型号测算
            danxinghao() {

                //先选区域
                // if (!this.ProMain.quyu) {

                //     this.$msg.msge("请先选择区域")

                // } else {

                    this.zhuijiaxinghao();

                    this.duoxinghaotijiao();

                    this.duoxinghao = false;

                //}

            },


            //追加多型号
            zhuijiaxinghao() {

                if (this.duoxinghaocesuan.length >= 15) {

                    this.$msg.msge("最多同时选择15个型号")

                } else {

                    this.$refs.form.validate((valid) => {

                        if (valid) {

                            this.duoxinghao = true;

                            this.form.daleiobj = _.find(this.list1, {oneLid: this.form.dalei});
                            this.form.wuliaoobj = _.find(this.list2, {prodcode: this.form.wuliao});

                            var p = true;

                            for (var c in this.duoxinghaocesuan) {

                                if (this.duoxinghaocesuan[c] == this.form.wuliao) {

                                    p = false;

                                }

                            }

                            //多型号的物料编码集
                            if (p) {

                                this.duoxinghaocesuan.push(this.form.wuliao);

                                console.log(this.form.wuliao, '看看编号')

                            }


                        }

                    });


                }


            },


            // huidiao() {
            //
            //     this.duoxinghao = false;
            //
            //     this.duoxinghaocesuan = [];
            //
            //     this.$refs.form.validate((valid) => {
            //
            //         if (valid) {
            //             this.form.daleiobj = _.find(this.list1,{oneLid:this.form.dalei});
            //             this.form.wuliaoobj = _.find(this.list2,{prodcode:this.form.wuliao});
            //
            //             this.choseObj(this.form);
            //
            //         }
            //
            //     });
            // },

            loadArea(i) {

                // this.queryq.fromtypelist = [
                //     "s","fw","sh"
                // ];

                // ss.chanpin.idselectList(this.queryq).then(rd => {
                //     this['list' + i] = rd;
                // })
                ss.chanpin.selectLeibie(this.queryq).then(rd => {
                    console.log(this.queryq,'rd1rd1rd1');
                    console.log(rd, 'rdrdrd')
                    this['list' + i] = rd;
                })
            },

            handleItemChange1(val) {
                console.log(val,"梁婕&&&&&&&&&&&&&&&&&&&&&&&");
                this.queryq.pcode = null;
                this.queryq.oneLid = val;
                this.selectWuliao(2);

            },
            selectWuliao(i) {
                ss.chanpin.selectMdmWuliao(this.queryq).then(rd => {
                    console.log(this.queryq);
                    console.log(rd, 'rdrdrd梁婕');
                    this['list' + i] = rd;
                })
           },

            //返回上页
            fanhuishangye() {

                //跳转特价页面
                //this.$router.push({path: '/rvlistshow'});
                   this.$router.go(-1);
            },


            huanxinghao() {

                this.showflag = true;

            },


            // //提交去申请特价
            // tijiaoshenqingtejia() {
            //
            //     console.log(this.marcode, '看看物料号')
            //
            //
            //     //跳转特价页面
            //     this.$router.push({
            //         path: '/pricenew',
            //         query: {
            //             marcode: this.marcode,
            //             wuliaoming: this.tableData[1].xinghao1,
            //             usercode: this._user.usercode,
            //             yonghuming: this._user.username,
            //             xiaoliang: this.tableData[8].xinghao1,
            //             danjia: this.tableData[9].xinghao1
            //         }
            //     });
            //
            //
            // },


            con(i) {
                console.log(i)
            },
            getit() {
                return 1
            },
            dblclick(v, h, c, d) {
                console.log(v, h, c, d)
            },
            arraySpanMethod({row, column, rowIndex, columnIndex}) {
                if (rowIndex % 3 === 0) {
                    if (columnIndex === 0) {
                        return [1, 4];
                    } else if (columnIndex === 1) {
                        return [0, 0];
                    }
                }
            },
            objectSpanMethod({row, column, rowIndex, columnIndex}) {

                //不是销售经理
                if (this.shifouxiaoshoujingli == false) {

                    if (columnIndex === 0) {
                        if (rowIndex === 0) {
                            return {
                                rowspan: 6,
                                colspan: 1
                            };
                        } else if (rowIndex === 6) {  // 当第7行就为正常的一行；要返回 把1行合并为一列
                            return {
                                rowspan: 7,
                                colspan: 1
                            };
                        } else if (rowIndex === 13) {
                            return {
                                rowspan: 3,
                                colspan: 1
                            }
                        } else if (rowIndex === 16) {
                            return {
                                rowspan: 4,
                                colspan: 1
                            }
                        } else if (rowIndex === 20) {
                            return {
                                rowspan: 18,
                                colspan: 1
                            }
                        } else if (rowIndex === 38) {
                            return {
                                rowspan: 2,
                                colspan: 1
                            }
                        } else if (rowIndex === 40) {
                            return {
                                rowspan: 4,
                                colspan: 1
                            }
                        } else if (rowIndex === 44) {
                            return {
                                rowspan: 2,
                                colspan: 1
                            }
                        } else {
                            return {
                                rowspan: 0,
                                colspan: 0
                            }
                        }
                    }
                    if (columnIndex === 1) {
                        if (rowIndex === 22) {
                            return {
                                rowspan: 2,
                                colspan: 1
                            };
                        } else if (rowIndex === 23) {
                            return {
                                rowspan: 0,
                                colspan: 0
                            };
                        } else if (rowIndex === 24) {
                            return {
                                rowspan: 2,
                                colspan: 1
                            };
                        } else if (rowIndex === 25) {
                            return {
                                rowspan: 0,
                                colspan: 0
                            };
                        } else if (rowIndex === 31) {
                            return {
                                rowspan: 2,
                                colspan: 1
                            };
                        } else if (rowIndex === 32) {
                            return {
                                rowspan: 0,
                                colspan: 0
                            };
                        } else if (rowIndex === 33) {
                            return {
                                rowspan: 2,
                                colspan: 1
                            };
                        } else if (rowIndex === 34) {
                            return {
                                rowspan: 0,
                                colspan: 0
                            };
                        } else if (rowIndex === 35) {
                            return {
                                rowspan: 2,
                                colspan: 1
                            };
                        } else if (rowIndex === 36) {
                            return {
                                rowspan: 0,
                                colspan: 0
                            };
                        } else {
                            return {
                                rowspan: 1,
                                colspan: 1
                            }
                        }
                    }
                    ;


                } else {//销售经理

                    if (columnIndex === 0) {
                        if (rowIndex === 0) {
                            return {
                                rowspan: 5,
                                colspan: 1
                            };
                        } else if (rowIndex === 6) {
                            return {
                                rowspan: 5,
                                colspan: 1
                            };
                        } else if (rowIndex === 21) {
                            return {
                                rowspan: 1,
                                colspan: 1
                            };
                        } else if (rowIndex === 30) {
                            return {
                                rowspan: 1,
                                colspan: 1
                            };
                        } else if(rowIndex === 16) {
                             return {
                                rowspan: 1,
                                colspan: 1
                            };
                        }else {
                            return {
                                rowspan: 0,
                                colspan: 0
                            }
                        }
                    }

                }


            },


            // //查询翻页
            // query() {
            //
            //     ss.FormulaNew.selectPage(this.q).then(rd => {
            //
            //         this.q.total = rd.total;
            //
            //         this.xiangmuchanpinlist = rd.records;
            //
            //         console.log(this.xiangmuchanpinlist, '看看查到多少项目产品')
            //
            //
            //         if (this.shoucijiaohu) {
            //
            //             //默认首次交互
            //             this.getconfigs(0);
            //
            //         }
            //
            //     })
            //
            // },


            //获取类型和编码
            huoquleixinghebianma() {

                // ss.FormulaNew.allvwselectList().then(rd => {
                //
                //
                //     var ins = [];
                //
                //     for(var t in rd){
                //
                //         var ts = {
                //
                //             label:rd[t].materialDescrition,
                //             value:rd[t].materialCode,
                //
                //
                //         }
                //
                //         ins.push(ts);
                //
                //     }
                //
                //     this.xiangmuchanpinlist = ins;
                //     console.log(this.xiangmuchanpinlist,"看看有没有")
                //
                //
                //     this.getconfigs(0);
                //
                //
                // })


            },


            // handleFilter() {
            //     this.q.pageNo = 1;
            //     this.query();
            // },


            // rules: {
            //     name: [
            //         {required: true, message: '请输入项目名称', trigger: 'blur'},
            //     ],
            // },


            //保修期选择方法
            repairchangetype(value) {
                console.log(value);
                console.log(this.repairtype);
            },


            //加载列
            addbiaotilie(listrd, allrate) {

                this.columndata = [];

                console.log(listrd)

                for (var c in listrd) {

                    console.log(c)

                    var cc = {

                        'prop': 'xinghao' + (new big(parseInt(c)).plus(1).toString()),
                        'label': '型号' + (new big(parseInt(c)).plus(1).toString()),

                    };


                    this.columndata.push(cc);


                }

                this.addshuju(listrd, allrate);

            },


            //加载列的数据
            addshuju(listrd, allrate) {

                this.alllastlist = [];

                //单页数据
                var csave = {};

                //遍历每个产品的单表
                for (var c in listrd) {
					console.log(listrd[c],"//////////////////////")
					for (var s in listrd[c]) {
						if (
							s == 'marcode'
							|| s == 'nonetypeLevel'
							|| s == 'opeLevel'
							|| s == 'productLevel'
							|| s == 'typeLevel'
						) {
							listrd[c][s] = listrd[c][s]
						}else{
							listrd[c][s] = parseFloat(listrd[c][s]) == '0'?'0':parseFloat(listrd[c][s]).toString()
							console.log(listrd[c][s],"..........................")
						}
					}
					
                    //单页数据
                    csave = {

                        //销量
                        "productNum": listrd[c].productNum == null ? "" : listrd[c].productNum,

                        //产品编码
                        "marcode": listrd[c].marcode == null ? "" : listrd[c].marcode,

                        //大类
                        "typeLevel": listrd[c].typeLevel == null ? "" : listrd[c].typeLevel,

                        //系列
                        "opeLevel": listrd[c].opeLevel == null ? "" : listrd[c].opeLevel,

                        //不知道是啥
                        "nonetypeLevel": listrd[c].nonetypeLevel == null ? "" : listrd[c].nonetypeLevel,

                        //产品型号
                        "productLevel": listrd[c].productLevel == null ? "" : listrd[c].productLevel,

                        //单台一级供价
                        "onemoney": listrd[c].onemoney == null ? "" : listrd[c].onemoney,

                        //专营商毛利率
                        "zhuanyingshangmaolilv": listrd[c].zhuanyingshangmaolilv == null ? "" : listrd[c].zhuanyingshangmaolilv,

                        //申请单价含税
                        "shenqingdanjia": listrd[c].shenqingdanjia == null ? "" : listrd[c].shenqingdanjia,

                        //折扣率
                        "zhekoulv": listrd[c].zhekoulv == null ? "" : listrd[c].zhekoulv+"",

                        //订单金额
                        "dingdanjine": listrd[c].dingdanjine == null ? "" : listrd[c].dingdanjine,

                        //不含税订单收入
                        "buhanshuishouru": listrd[c].buhanshuishouru == null ? "" : listrd[c].buhanshuishouru,

                        //单台成本
                        "dantaichengben": listrd[c].dantaichengben == null ? "" : listrd[c].dantaichengben,

                        //制造费用
                        "zhizaofeiyong": listrd[c].zhizaofeiyong == null ? "" : listrd[c].zhizaofeiyong,

                        //材料的制造费用率
                        "zhizaofeiyonglv": listrd[c].zhizaofeiyonglv == null ? "" : listrd[c].zhizaofeiyonglv,

                        //单台体积
                        "wuliufeiyongdanweitiji": listrd[c].wuliufeiyongdanweitiji == null ? "" : listrd[c].wuliufeiyongdanweitiji,

                        //单台安装费
                        "dantaianzhuangfei": listrd[c].dantaianzhuangfei == null ? "" : listrd[c].dantaianzhuangfei,

                        //安装费
                        "anzhuangfeianzhuangfei": listrd[c].anzhuangfeianzhuangfei == null ? "" : listrd[c].anzhuangfeianzhuangfei,

                        //维修基金
                        "weixiujijin": listrd[c].weixiujijin == null ? "" : listrd[c].weixiujijin,

                        //盈亏平衡含税价
                        "yingkuipingheng": listrd[c].yingkuipingheng == null ? "" : listrd[c].yingkuipingheng,

                        //材料毛利
                        "yinglicailiaomaoli": listrd[c].yinglicailiaomaoli == null ? "" : listrd[c].yinglicailiaomaoli,

                        //经营贡献
                        "jingyinggongxian": listrd[c].jingyinggongxian == null ? "" : listrd[c].jingyinggongxian,

                        //盈利 利润
                        "yinglilirun": listrd[c].yinglilirun == null ? "" : listrd[c].yinglilirun,

                        //毛利 成本合计
                        "maolichengbenheji": listrd[c].maolichengbenheji == null ? "" : listrd[c].maolichengbenheji,

                        //毛利 毛利
                        "maolimaoli": listrd[c].maolimaoli == null ? "" : listrd[c].maolimaoli,

                        //毛利 材料毛利率
                        "maolimaolilv": listrd[c].maolimaolilv == null ? "" : listrd[c].maolimaolilv,

                        //直接费用 物流费用 运费
                        "wuliufeiyongyunfei": listrd[c].wuliufeiyongyunfei == null ? "" : listrd[c].wuliufeiyongyunfei,

                        //直接费用 维修费  18年到产品实际费用
                        "zhijiefeiyongweixiufei": listrd[c].zhijiefeiyongweixiufei == null ? "" : listrd[c].zhijiefeiyongweixiufei,

                        //直接费用 备件费 18年到产品实际费用
                        "zhijiefeiyongbeijianfei": listrd[c].zhijiefeiyongbeijianfei == null ? "" : listrd[c].zhijiefeiyongbeijianfei,

                        //直接费用 退换机 18年到产品实际费用
                        "zhijiefeiyongtuihuanjifei": listrd[c].zhijiefeiyongtuihuanjifei == null ? "" : listrd[c].zhijiefeiyongtuihuanjifei,

                        //直接费用 退换机 18年到产品实际费用
                        "zijinchengben": listrd[c].zijinchengben == null ? "" : listrd[c].zijinchengben,

                        //中标服务费
                        "zhongbiaofuwufei": listrd[c].zhongbiaofuwufei == null ? "" : listrd[c].zhongbiaofuwufei,

                        //直接费用 税费 其他税费
                        "shuifeiqitashuifei": listrd[c].shuifeiqitashuifei == null ? "" : listrd[c].shuifeiqitashuifei,

                        //销售费用 销售人工
                        "xiaoshoufeiyongrengong": listrd[c].xiaoshoufeiyongrengong == null ? "" : listrd[c].xiaoshoufeiyongrengong,

                        //销售费用 销售组织运营
                        "xiaoshouzuzhiyunying": listrd[c].xiaoshouzuzhiyunying == null ? "" : listrd[c].xiaoshouzuzhiyunying,

                        //研发费用 研发人工
                        "yanfarengong": listrd[c].yanfarengong == null ? "" : listrd[c].yanfarengong,


                        //研发费用 研发组织运营
                        "yanfayunying": listrd[c].yanfayunying == null ? "" : listrd[c].yanfayunying,

                        //直接费用小计
                        "zhijiefeiyongxiaoji": listrd[c].zhijiefeiyongxiaoji == null ? "" : listrd[c].zhijiefeiyongxiaoji,

                        //经营贡献 经营贡献 经营贡献
                        "jingyinggongxiansan": listrd[c].jingyinggongxiansan == null ? "" : listrd[c].jingyinggongxiansan,

                        //经营贡献 经营贡献率 经营贡献率
                        "jingyinggongxianlv": listrd[c].jingyinggongxianlv == null ? "" : listrd[c].jingyinggongxianlv,

                        //平台费用 销售费用 自产费用率
                        "pingtaixiaoshoufeiyong": listrd[c].pingtaixiaoshoufeiyong == null ? "" : listrd[c].pingtaixiaoshoufeiyong,

                        //平台费用 管理费用 全部产品费用率
                        "pingtaiguanlifeiyong": listrd[c].pingtaiguanlifeiyong == null ? "" : listrd[c].pingtaiguanlifeiyong,

                        //平台费用 研发费用 自产研发费
                        "pingtaiyanfafeiyong": listrd[c].pingtaiyanfafeiyong == null ? "" : listrd[c].pingtaiyanfafeiyong,

                        //平台费用 平台费用小计
                        "pingtaifeiyongxiaoji": listrd[c].pingtaifeiyongxiaoji == null ? "" : listrd[c].pingtaifeiyongxiaoji,

                        //利润 利润  利润
                        "lirunsan": listrd[c].lirunsan == null ? "" : listrd[c].lirunsan,

                        //利润 利润率  利润率
                        "lirunlirunlv": listrd[c].lirunlirunlv == null ? "" : listrd[c].lirunlirunlv,

                        //附加成本  赠送耗材、周转机等成本 前台输入
                        "fujiachengben": listrd[c].fujiachengben == null ? "" : listrd[c].fujiachengben,

                        //终端成交价
                        "zhongduanchengjiaojia": listrd[c].zhongduanchengjiaojia == null ? "" : listrd[c].zhongduanchengjiaojia,

                        //损益表材料毛利率
                        "sunyibiaocailiaomaolilv": listrd[c].sunyibiaocailiaomaolilv == null ? "" : listrd[c].sunyibiaocailiaomaolilv,

                    }

                    console.log(listrd[c].sunyibiaocailiaomaolilv, '看看那没拿到值aaaa????')


                    this.alllastlist.push(csave);


                    // this.ProMain.zhuanyingshangmaolilv = csave.zhuanyingshangmaolilv;

                }


                this.tableData = [{
                    message: '基本信息',
                    coding: '编码',
                    shuoming: '-',
                    biaozhun: '-',
                    hejiL: '-',
                    hejiE: '-',
                    xinghao1: this.alllastlist[0].marcode || '',
                    xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].marcode,
                    xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].marcode,
                    xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].marcode,
                    xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].marcode,
					xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].marcode,
					xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].marcode,
					xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].marcode,
					xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].marcode,
					xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].marcode,
					xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].marcode,
					xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].marcode,
					xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].marcode,
					xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].marcode,
					xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].marcode,

                }, {
                    coding: '型号',
                    biaozhun: '-',
                    shuoming: '-',
                    hejiL: '-',
                    hejiE: '-',
                    xinghao1: this.alllastlist[0].productLevel || '',
					xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].productLevel,
					xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].productLevel,
					xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].productLevel,
					xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].productLevel,
					xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].productLevel,
					xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].productLevel,
					xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].productLevel,
					xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].productLevel,
					xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].productLevel,
					xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].productLevel,
					xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].productLevel,
					xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].productLevel,
					xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].productLevel,
					xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].productLevel,

                }, {
                    coding: '产品大类',
                    biaozhun: '-',
                    shuoming: '-',
                    hejiL: '-',
                    hejiE: '-',
                    xinghao1: this.alllastlist[0].typeLevel || '',
					xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].typeLevel,
					xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].typeLevel,
					xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].typeLevel,
					xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].typeLevel,
					xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].typeLevel,
					xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].typeLevel,
					xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].typeLevel,
					xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].typeLevel,
					xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].typeLevel,
					xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].typeLevel,
					xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].typeLevel,
					xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].typeLevel,
					xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].typeLevel,
					xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].typeLevel,


                }, {
                    coding: '产品系列',
                    biaozhun: '-',
                    shuoming: '-',
                    hejiL: '-',
                    hejiE: '-',

                    xinghao1: this.alllastlist[0].opeLevel || '',
					xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].opeLevel,
					xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].opeLevel,
					xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].opeLevel,
					xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].opeLevel,
					xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].opeLevel,
					xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].opeLevel,
					xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].opeLevel,
					xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].opeLevel,
					xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].opeLevel,
					xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].opeLevel,
					xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].opeLevel,
					xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].opeLevel,
					xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].opeLevel,
					xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].opeLevel,


                },
                    {
                        coding: '终端成交价',
                        biaozhun: '-',
                        shuoming: '-',
                        hejiL: '-',
                        hejiE: allrate.zhongduanchengjiaojia || '',
                        canshu: 'zhongduanchengjiaojia',
                        xinghao1: this.alllastlist[0].zhongduanchengjiaojia || '',
						xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].zhongduanchengjiaojia,
						xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].zhongduanchengjiaojia,
						xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].zhongduanchengjiaojia,
						xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].zhongduanchengjiaojia,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].zhongduanchengjiaojia,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].zhongduanchengjiaojia,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].zhongduanchengjiaojia,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].zhongduanchengjiaojia,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].zhongduanchengjiaojia,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].zhongduanchengjiaojia,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].zhongduanchengjiaojia,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].zhongduanchengjiaojia,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].zhongduanchengjiaojia,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].zhongduanchengjiaojia,

                        marcode1: this.alllastlist[0].marcode || '',
                        marcode2: this.alllastlist[1] == null ? '' : this.alllastlist[1].marcode,
                        marcode3: this.alllastlist[2] == null ? '' : this.alllastlist[2].marcode,
                        marcode4: this.alllastlist[3] == null ? '' : this.alllastlist[3].marcode,
                        marcode5: this.alllastlist[4] == null ? '' : this.alllastlist[4].marcode,
						marcode6: this.alllastlist[5] == null ? '' : this.alllastlist[5].marcode,
						marcode7: this.alllastlist[6] == null ? '' : this.alllastlist[6].marcode,
						marcode8: this.alllastlist[7] == null ? '' : this.alllastlist[7].marcode,
						marcode9: this.alllastlist[8] == null ? '' : this.alllastlist[8].marcode,
						marcode10: this.alllastlist[9] == null ? '' : this.alllastlist[9].marcode,
						marcode11: this.alllastlist[10] == null ? '' : this.alllastlist[10].marcode,
						marcode12: this.alllastlist[11] == null ? '' : this.alllastlist[11].marcode,
						marcode13: this.alllastlist[12] == null ? '' : this.alllastlist[12].marcode,
						marcode14: this.alllastlist[13] == null ? '' : this.alllastlist[13].marcode,
						marcode15: this.alllastlist[14] == null ? '' : this.alllastlist[14].marcode,
                        canshuxulie:'zhongduanchengjiaojia',

                    },
                    {
                        coding: '专营商毛利率',
                        biaozhun: '-',
                        shuoming: '-',
                        hejiL: '-',
                        hejiE: allrate.zhuanyingshangmaolilv || '',

                        xinghao1: this.alllastlist[0].zhuanyingshangmaolilv || '',
						xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].zhuanyingshangmaolilv,
						xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].zhuanyingshangmaolilv,
						xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].zhuanyingshangmaolilv,
						xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].zhuanyingshangmaolilv,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].zhuanyingshangmaolilv,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].zhuanyingshangmaolilv,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].zhuanyingshangmaolilv,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].zhuanyingshangmaolilv,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].zhuanyingshangmaolilv,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].zhuanyingshangmaolilv,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].zhuanyingshangmaolilv,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].zhuanyingshangmaolilv,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].zhuanyingshangmaolilv,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].zhuanyingshangmaolilv,
                        canshuxulie:'zhuanyingshangmaolilv',

                    }, {
                        message: '收入',
                        coding: '单台一级供价',
                        biaozhun: '-',
                        shuoming: '-',
                        hejiL: '-',
                        hejiE: allrate.onemoney || '',

                        xinghao1: this.alllastlist[0].onemoney || '',
						xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].onemoney,
						xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].onemoney,
						xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].onemoney,
						xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].onemoney,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].onemoney,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].onemoney,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].onemoney,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].onemoney,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].onemoney,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].onemoney,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].onemoney,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].onemoney,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].onemoney,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].onemoney,
                        canshuxulie:'onemoney',

                    }, {
                        coding: '折扣率',
                        biaozhun: '-',
                        shuoming: '-',
                        hejiL: '-',
                        hejiE: allrate.zhekoulv+"" || '',

                        xinghao1: this.alllastlist[0].zhekoulv+"" || '',
						xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].zhekoulv,
						xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].zhekoulv,
						xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].zhekoulv,
						xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].zhekoulv,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].zhekoulv,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].zhekoulv,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].zhekoulv,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].zhekoulv,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].zhekoulv,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].zhekoulv,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].zhekoulv,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].zhekoulv,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].zhekoulv,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].zhekoulv,

                        canshuxulie:'zhekoulv',
                    },
                    {
                        coding: '销量',
                        biaozhun: '-',
                        shuoming: '-',
                        hejiL: '-',
                        hejiE: allrate.productNum || '',

                        xinghao1: this.alllastlist[0].productNum || '',
						xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].productNum,
						xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].productNum,
						xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].productNum,
						xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].productNum,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].productNum,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].productNum,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].productNum,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].productNum,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].productNum,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].productNum,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].productNum,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].productNum,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].productNum,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].productNum,
                        canshuxulie:'productNum',
                    },
                    {
                        coding: '申请单价(含税)',
                        biaozhun: '-',
                        shuoming: '-',
                        hejiL: '-',
                        hejiE: allrate.shenqingdanjia || '',
                        canshu: 'shenqingdanjia',
                        xinghao1: this.alllastlist[0].shenqingdanjia || '',
						xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].shenqingdanjia,
						xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].shenqingdanjia,
						xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].shenqingdanjia,
						xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].shenqingdanjia,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].shenqingdanjia,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].shenqingdanjia,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].shenqingdanjia,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].shenqingdanjia,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].shenqingdanjia,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].shenqingdanjia,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].shenqingdanjia,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].shenqingdanjia,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].shenqingdanjia,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].shenqingdanjia,

                        marcode1: this.alllastlist[0].marcode || '',
                        marcode2: this.alllastlist[1] == null ? '' : this.alllastlist[1].marcode,
                        marcode3: this.alllastlist[2] == null ? '' : this.alllastlist[2].marcode,
                        marcode4: this.alllastlist[3] == null ? '' : this.alllastlist[3].marcode,
                        marcode5: this.alllastlist[4] == null ? '' : this.alllastlist[4].marcode,
						marcode6: this.alllastlist[5] == null ? '' : this.alllastlist[5].marcode,
						marcode7: this.alllastlist[6] == null ? '' : this.alllastlist[6].marcode,
						marcode8: this.alllastlist[7] == null ? '' : this.alllastlist[7].marcode,
						marcode9: this.alllastlist[8] == null ? '' : this.alllastlist[8].marcode,
						marcode10: this.alllastlist[9] == null ? '' : this.alllastlist[9].marcode,
						marcode11: this.alllastlist[10] == null ? '' : this.alllastlist[10].marcode,
						marcode12: this.alllastlist[11] == null ? '' : this.alllastlist[11].marcode,
						marcode13: this.alllastlist[12] == null ? '' : this.alllastlist[12].marcode,
						marcode14: this.alllastlist[13] == null ? '' : this.alllastlist[13].marcode,
						marcode15: this.alllastlist[14] == null ? '' : this.alllastlist[14].marcode,
                        canshuxulie:'shenqingdanjia',
                    },
                    {
                        coding: '订单金额',
                        biaozhun: '-',
                        shuoming: '-',
                        hejiL: '-',
                        hejiE: allrate.dingdanjine || '',

                        xinghao1: this.alllastlist[0].dingdanjine || '',
						xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].dingdanjine,
						xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].dingdanjine,
						xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].dingdanjine,
						xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].dingdanjine,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].dingdanjine,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].dingdanjine,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].dingdanjine,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].dingdanjine,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].dingdanjine,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].dingdanjine,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].dingdanjine,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].dingdanjine,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].dingdanjine,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].dingdanjine,

                        canshuxulie:'dingdanjine',
                    },
                    {
                        coding: '不含税订单收入',
                        biaozhun: '-',
                        shuoming: '-',
                        hejiL: '-',
                        hejiE: allrate.buhanshuishouru || '',

                        xinghao1: this.alllastlist[0].buhanshuishouru || '',
						xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].buhanshuishouru,
						xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].buhanshuishouru,
						xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].buhanshuishouru,
						xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].buhanshuishouru,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].buhanshuishouru,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].buhanshuishouru,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].buhanshuishouru,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].buhanshuishouru,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].buhanshuishouru,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].buhanshuishouru,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].buhanshuishouru,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].buhanshuishouru,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].buhanshuishouru,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].buhanshuishouru,

                        canshuxulie:'buhanshuishouru',
                    },
                    {
                        coding: '盈亏平衡含税价',
                        biaozhun: '-',
                        shuoming: '-',
                        hejiL: '-',
                        hejiE: allrate.yingkuipingheng || '',

                        xinghao1: this.alllastlist[0].yingkuipingheng || '',
						xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].yingkuipingheng,
						xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].yingkuipingheng,
						xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].yingkuipingheng,
						xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].yingkuipingheng,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].yingkuipingheng,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].yingkuipingheng,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].yingkuipingheng,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].yingkuipingheng,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].yingkuipingheng,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].yingkuipingheng,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].yingkuipingheng,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].yingkuipingheng,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].yingkuipingheng,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].yingkuipingheng,

                        canshuxulie:'yingkuipingheng',
                    },
                    {
                        message: '盈利情况',
                        coding: '材料毛利',
                        shuoming: '-',
                        biaozhun: '-',
                        hejiL: ((allrate.yinglicailiaomaoli == null || allrate.yinglicailiaomaoli == '' || allrate.yinglicailiaomaoli == 0 || allrate.yinglicailiaomaoli == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.yinglicailiaomaoli)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
                        hejiE: allrate.maolimaoli || '',

                        xinghao1: this.alllastlist[0].yinglicailiaomaoli || '',
						xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].yinglicailiaomaoli,
						xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].yinglicailiaomaoli,
						xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].yinglicailiaomaoli,
						xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].yinglicailiaomaoli,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].yinglicailiaomaoli,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].yinglicailiaomaoli,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].yinglicailiaomaoli,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].yinglicailiaomaoli,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].yinglicailiaomaoli,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].yinglicailiaomaoli,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].yinglicailiaomaoli,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].yinglicailiaomaoli,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].yinglicailiaomaoli,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].yinglicailiaomaoli,

                        canshuxulie:'yinglicailiaomaoli',
                    },
                    {
                        coding: '经营贡献',
                        biaozhun: '-',
                        shuoming: '-',
                        hejiL: ((allrate.jingyinggongxian == null || allrate.jingyinggongxian == '' || allrate.jingyinggongxian == 0 || allrate.jingyinggongxian == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.jingyinggongxian)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
                        hejiE: allrate.jingyinggongxiansan || '',

                        xinghao1: this.alllastlist[0].jingyinggongxian || '',
						xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].jingyinggongxian,
						xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].jingyinggongxian,
						xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].jingyinggongxian,
						xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].jingyinggongxian,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].jingyinggongxian,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].jingyinggongxian,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].jingyinggongxian,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].jingyinggongxian,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].jingyinggongxian,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].jingyinggongxian,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].jingyinggongxian,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].jingyinggongxian,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].jingyinggongxian,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].jingyinggongxian,

                        canshuxulie:'jingyinggongxian',
                    },
                    {
                        coding: '利润',
                        biaozhun: '-',
                        shuoming: '-',
                        hejiL: ((allrate.yinglilirun == null || allrate.yinglilirun == '' || allrate.yinglilirun == 0 || allrate.yinglilirun == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.yinglilirun)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
                        hejiE: allrate.lirunsan || '',

                        xinghao1: this.alllastlist[0].yinglilirun || '',
						xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].yinglilirun,
						xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].yinglilirun,
						xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].yinglilirun,
						xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].yinglilirun,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].yinglilirun,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].yinglilirun,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].yinglilirun,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].yinglilirun,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].yinglilirun,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].yinglilirun,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].yinglilirun,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].yinglilirun,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].yinglilirun,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].yinglilirun,

                        canshuxulie:'yinglilirun',
                    },
                    {
                        message: '毛利',
                        coding: '单台成本',
                        shuoming: '测算当月BOM成本',
                        biaozhun: '-',
                        hejiL: '-',
                        hejiE: allrate.dantaichengben || '',

                        xinghao1: this.alllastlist[0].dantaichengben || '',
						xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].dantaichengben,
						xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].dantaichengben,
						xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].dantaichengben,
						xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].dantaichengben,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].dantaichengben,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].dantaichengben,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].dantaichengben,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].dantaichengben,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].dantaichengben,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].dantaichengben,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].dantaichengben,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].dantaichengben,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].dantaichengben,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].dantaichengben,

                        canshuxulie:'dantaichengben',
                    },
                    {
                        coding: '成本合计',
                        biaozhun: '-',
                        shuoming: '-',
                        hejiL: ((allrate.maolichengbenheji == null || allrate.maolichengbenheji == '' || allrate.maolichengbenheji == 0 || allrate.maolichengbenheji == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.maolichengbenheji)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
                        hejiE: allrate.maolichengbenheji || '',

                        xinghao1: this.alllastlist[0].maolichengbenheji || '',
						xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].maolichengbenheji,
						xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].maolichengbenheji,
						xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].maolichengbenheji,
						xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].maolichengbenheji,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].maolichengbenheji,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].maolichengbenheji,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].maolichengbenheji,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].maolichengbenheji,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].maolichengbenheji,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].maolichengbenheji,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].maolichengbenheji,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].maolichengbenheji,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].maolichengbenheji,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].maolichengbenheji,

                        canshuxulie:'maolichengbenheji',
                    },
                    {
                        coding: '毛利',
                        biaozhun: '-',
                        shuoming: '-',
                        hejiL: ((allrate.maolimaoli == null || allrate.maolimaoli == '' || allrate.maolimaoli == 0 || allrate.maolimaoli == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.maolimaoli)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
                        hejiE: allrate.maolimaoli || '',

                        xinghao1: this.alllastlist[0].maolimaoli || '',
						xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].maolimaoli,
						xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].maolimaoli,
						xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].maolimaoli,
						xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].maolimaoli,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].maolimaoli,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].maolimaoli,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].maolimaoli,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].maolimaoli,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].maolimaoli,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].maolimaoli,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].maolimaoli,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].maolimaoli,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].maolimaoli,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].maolimaoli,

                        canshuxulie:'maolimaoli',

                    },
                    {
                        coding: '材料毛利率',
                        biaozhun: '-',
                        hejiL: '-',
                        shuoming: '-',
                        hejiE: allrate.maolimaolilv || '',

                        xinghao1: this.alllastlist[0].maolimaolilv || '',
						xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].maolimaolilv,
						xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].maolimaolilv,
						xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].maolimaolilv,
						xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].maolimaolilv,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].maolimaolilv,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].maolimaolilv,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].maolimaolilv,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].maolimaolilv,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].maolimaolilv,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].maolimaolilv,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].maolimaolilv,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].maolimaolilv,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].maolimaolilv,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].maolimaolilv,

                        canshuxulie:'maolimaolilv',
                    },
                    {
                        message: '直接费用',
                        coding: '制造费用',
                        shuoming: '材料的制造费用率',
                        biaozhun: '-',
                        hejiL: ((allrate.zhizaofeiyong == null || allrate.zhizaofeiyong == '' || allrate.zhizaofeiyong == 0 || allrate.zhizaofeiyong == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.zhizaofeiyong)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
                        hejiE: allrate.zhizaofeiyong || '',

                        xinghao1: this.alllastlist[0].zhizaofeiyong || '',
						xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].zhizaofeiyong,
						xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].zhizaofeiyong,
						xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].zhizaofeiyong,
						xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].zhizaofeiyong,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].zhizaofeiyong,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].zhizaofeiyong,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].zhizaofeiyong,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].zhizaofeiyong,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].zhizaofeiyong,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].zhizaofeiyong,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].zhizaofeiyong,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].zhizaofeiyong,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].zhizaofeiyong,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].zhizaofeiyong,
                        canshuxulie:'zhizaofeiyong',
                    },
                    {
                        message: '直接费用',
                        coding: '附加成本',
                        shuoming: '赠送耗材、周转机等成本',
                        biaozhun: '-',
                        hejiL: ((allrate.fujiachengben == null || allrate.fujiachengben == '' || allrate.fujiachengben == 0 || allrate.fujiachengben == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.fujiachengben)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
                        hejiE: allrate.fujiachengben || '',
                        canshu: 'fujiachengben',
                        xinghao1: this.alllastlist[0].fujiachengben || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].fujiachengben,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].fujiachengben,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].fujiachengben,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].fujiachengben,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].fujiachengben,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].fujiachengben,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].fujiachengben,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].fujiachengben,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].fujiachengben,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].fujiachengben,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].fujiachengben,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].fujiachengben,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].fujiachengben,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].fujiachengben,
                        marcode1: this.alllastlist[0].marcode || '',
                        marcode2: this.alllastlist[1] == null ? '' : this.alllastlist[1].marcode,
                        marcode3: this.alllastlist[2] == null ? '' : this.alllastlist[2].marcode,
                        marcode4: this.alllastlist[3] == null ? '' : this.alllastlist[3].marcode,
                        marcode5: this.alllastlist[4] == null ? '' : this.alllastlist[4].marcode,
						marcode6: this.alllastlist[5] == null ? '' : this.alllastlist[5].marcode,
						marcode7: this.alllastlist[6] == null ? '' : this.alllastlist[6].marcode,
						marcode8: this.alllastlist[7] == null ? '' : this.alllastlist[7].marcode,
						marcode9: this.alllastlist[8] == null ? '' : this.alllastlist[8].marcode,
						marcode10: this.alllastlist[9] == null ? '' : this.alllastlist[9].marcode,
						marcode11: this.alllastlist[10] == null ? '' : this.alllastlist[10].marcode,
						marcode12: this.alllastlist[11] == null ? '' : this.alllastlist[11].marcode,
						marcode13: this.alllastlist[12] == null ? '' : this.alllastlist[12].marcode,
						marcode14: this.alllastlist[13] == null ? '' : this.alllastlist[13].marcode,
						marcode15: this.alllastlist[14] == null ? '' : this.alllastlist[14].marcode,
                        canshuxulie:'fujiachengben',
                    },
                    {
                        coding: '物流费用',
                        shuoming: '单位体积',
                        biaozhun: '-',
                        hejiL: '-',
                        hejiE: allrate.wuliufeiyongdanweitiji || '',

                        xinghao1: this.alllastlist[0].wuliufeiyongdanweitiji || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].wuliufeiyongdanweitiji,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].wuliufeiyongdanweitiji,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].wuliufeiyongdanweitiji,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].wuliufeiyongdanweitiji,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].wuliufeiyongdanweitiji,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].wuliufeiyongdanweitiji,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].wuliufeiyongdanweitiji,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].wuliufeiyongdanweitiji,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].wuliufeiyongdanweitiji,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].wuliufeiyongdanweitiji,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].wuliufeiyongdanweitiji,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].wuliufeiyongdanweitiji,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].wuliufeiyongdanweitiji,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].wuliufeiyongdanweitiji,
                        canshuxulie:'wuliufeiyongdanweitiji',
                    },
                    {
                        coding: '-',
                        shuoming: '运费',
                        biaozhun: '-',
                        hejiL: ((allrate.wuliufeiyongyunfei == null || allrate.wuliufeiyongyunfei == '' || allrate.wuliufeiyongyunfei == 0 || allrate.wuliufeiyongyunfei == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.wuliufeiyongyunfei)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
                        hejiE: allrate.wuliufeiyongyunfei || '',

                        xinghao1: this.alllastlist[0].wuliufeiyongyunfei || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].wuliufeiyongyunfei,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].wuliufeiyongyunfei,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].wuliufeiyongyunfei,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].wuliufeiyongyunfei,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].wuliufeiyongyunfei,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].wuliufeiyongyunfei,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].wuliufeiyongyunfei,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].wuliufeiyongyunfei,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].wuliufeiyongyunfei,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].wuliufeiyongyunfei,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].wuliufeiyongyunfei,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].wuliufeiyongyunfei,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].wuliufeiyongyunfei,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].wuliufeiyongyunfei,
                        canshuxulie:'wuliufeiyongyunfei',
                    },
                    {
                        coding: '安装费用',
                        shuoming: '单台安装费',
                        biaozhun: '-',
                        hejiL: '-',
                        hejiE: allrate.dantaianzhuangfei || '',

                        xinghao1: this.alllastlist[0].dantaianzhuangfei || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].dantaianzhuangfei,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].dantaianzhuangfei,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].dantaianzhuangfei,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].dantaianzhuangfei,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].dantaianzhuangfei,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].dantaianzhuangfei,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].dantaianzhuangfei,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].dantaianzhuangfei,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].dantaianzhuangfei,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].dantaianzhuangfei,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].dantaianzhuangfei,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].dantaianzhuangfei,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].dantaianzhuangfei,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].dantaianzhuangfei,
                        canshuxulie:'dantaianzhuangfei',
                    },
                    {
                        coding: '-',
                        shuoming: '安装费',
                        biaozhun: '-',
                        hejiL: ((allrate.anzhuangfeianzhuangfei == null || allrate.anzhuangfeianzhuangfei == '' || allrate.anzhuangfeianzhuangfei == 0 || allrate.anzhuangfeianzhuangfei == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.anzhuangfeianzhuangfei)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
                        hejiE: allrate.anzhuangfeianzhuangfei || '',

                        xinghao1: this.alllastlist[0].anzhuangfeianzhuangfei || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].anzhuangfeianzhuangfei,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].anzhuangfeianzhuangfei,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].anzhuangfeianzhuangfei,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].anzhuangfeianzhuangfei,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].anzhuangfeianzhuangfei,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].anzhuangfeianzhuangfei,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].anzhuangfeianzhuangfei,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].anzhuangfeianzhuangfei,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].anzhuangfeianzhuangfei,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].anzhuangfeianzhuangfei,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].anzhuangfeianzhuangfei,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].anzhuangfeianzhuangfei,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].anzhuangfeianzhuangfei,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].anzhuangfeianzhuangfei,
                        canshuxulie:'anzhuangfeianzhuangfei',
                    },
                    {
                        coding: '维修费',
                        shuoming: '18年到产品实际费用',
                        biaozhun: '-',
                        hejiL: ((allrate.zhijiefeiyongweixiufei == null || allrate.zhijiefeiyongweixiufei == '' || allrate.zhijiefeiyongweixiufei == 0 || allrate.zhijiefeiyongweixiufei == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.zhijiefeiyongweixiufei)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
                        hejiE: allrate.zhijiefeiyongweixiufei || '',

                        xinghao1: this.alllastlist[0].zhijiefeiyongweixiufei || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].zhijiefeiyongweixiufei,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].zhijiefeiyongweixiufei,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].zhijiefeiyongweixiufei,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].zhijiefeiyongweixiufei,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].zhijiefeiyongweixiufei,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].zhijiefeiyongweixiufei,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].zhijiefeiyongweixiufei,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].zhijiefeiyongweixiufei,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].zhijiefeiyongweixiufei,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].zhijiefeiyongweixiufei,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].zhijiefeiyongweixiufei,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].zhijiefeiyongweixiufei,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].zhijiefeiyongweixiufei,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].zhijiefeiyongweixiufei,
                        canshuxulie:'zhijiefeiyongweixiufei',
                    },
                    {
                        coding: '备件费',
                        shuoming: '18年到产品实际费用',
                        biaozhun: '-',
                        hejiL: ((allrate.zhijiefeiyongbeijianfei == null || allrate.zhijiefeiyongbeijianfei == '' || allrate.zhijiefeiyongbeijianfei == 0 || allrate.zhijiefeiyongbeijianfei == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.zhijiefeiyongbeijianfei)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
                        hejiE: allrate.zhijiefeiyongbeijianfei || '',

                        xinghao1: this.alllastlist[0].zhijiefeiyongbeijianfei || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].zhijiefeiyongbeijianfei,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].zhijiefeiyongbeijianfei,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].zhijiefeiyongbeijianfei,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].zhijiefeiyongbeijianfei,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].zhijiefeiyongbeijianfei,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].zhijiefeiyongbeijianfei,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].zhijiefeiyongbeijianfei,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].zhijiefeiyongbeijianfei,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].zhijiefeiyongbeijianfei,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].zhijiefeiyongbeijianfei,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].zhijiefeiyongbeijianfei,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].zhijiefeiyongbeijianfei,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].zhijiefeiyongbeijianfei,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].zhijiefeiyongbeijianfei,
                        canshuxulie:'zhijiefeiyongbeijianfei',
                    },
                    {
                        coding: '退换机',
                        shuoming: '18年到产品实际费用',
                        biaozhun: '-',
                        hejiL: ((allrate.zhijiefeiyongtuihuanjifei == null || allrate.zhijiefeiyongtuihuanjifei == '' || allrate.zhijiefeiyongtuihuanjifei == 0 || allrate.zhijiefeiyongtuihuanjifei == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.zhijiefeiyongtuihuanjifei)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
                        hejiE: allrate.zhijiefeiyongtuihuanjifei || '',

                        xinghao1: this.alllastlist[0].zhijiefeiyongtuihuanjifei || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].zhijiefeiyongtuihuanjifei,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].zhijiefeiyongtuihuanjifei,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].zhijiefeiyongtuihuanjifei,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].zhijiefeiyongtuihuanjifei,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].zhijiefeiyongtuihuanjifei,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].zhijiefeiyongtuihuanjifei,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].zhijiefeiyongtuihuanjifei,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].zhijiefeiyongtuihuanjifei,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].zhijiefeiyongtuihuanjifei,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].zhijiefeiyongtuihuanjifei,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].zhijiefeiyongtuihuanjifei,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].zhijiefeiyongtuihuanjifei,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].zhijiefeiyongtuihuanjifei,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].zhijiefeiyongtuihuanjifei,
                        canshuxulie:'zhijiefeiyongtuihuanjifei',
                    },
                    {
                        coding: '资金成本',
                        shuoming: '资金成本损失',
                        biaozhun: '-',
                        hejiL: ((allrate.zijinchengben == null || allrate.zijinchengben == '' || allrate.zijinchengben == 0 || allrate.zijinchengben == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.zijinchengben)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
                        hejiE: allrate.zijinchengben || '',

                        xinghao1: this.alllastlist[0].zijinchengben || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].zijinchengben,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].zijinchengben,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].zijinchengben,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].zijinchengben,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].zijinchengben,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].zijinchengben,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].zijinchengben,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].zijinchengben,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].zijinchengben,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].zijinchengben,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].zijinchengben,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].zijinchengben,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].zijinchengben,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].zijinchengben,
                        canshuxulie:'zijinchengben',
                    },
                    {
                        message: '直接费用',
                        coding: '中标服务费',
                        shuoming: '-',
                        biaozhun: '-',
                        hejiL: ((allrate.zhongbiaofuwufei == null || allrate.zhongbiaofuwufei == '' || allrate.zhongbiaofuwufei == 0 || allrate.zhongbiaofuwufei == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.zhongbiaofuwufei)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
                        hejiE: allrate.zhongbiaofuwufei || '',
                        canshu: 'zhongbiaofuwufei',
                        xinghao1: this.alllastlist[0].zhongbiaofuwufei || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].zhongbiaofuwufei,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].zhongbiaofuwufei,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].zhongbiaofuwufei,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].zhongbiaofuwufei,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].zhongbiaofuwufei,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].zhongbiaofuwufei,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].zhongbiaofuwufei,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].zhongbiaofuwufei,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].zhongbiaofuwufei,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].zhongbiaofuwufei,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].zhongbiaofuwufei,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].zhongbiaofuwufei,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].zhongbiaofuwufei,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].zhongbiaofuwufei,
                        marcode1: this.alllastlist[0].marcode || '',
                        marcode2: this.alllastlist[1] == null ? '' : this.alllastlist[1].marcode,
                        marcode3: this.alllastlist[2] == null ? '' : this.alllastlist[2].marcode,
                        marcode4: this.alllastlist[3] == null ? '' : this.alllastlist[3].marcode,
                        marcode5: this.alllastlist[4] == null ? '' : this.alllastlist[4].marcode,
						marcode6: this.alllastlist[5] == null ? '' : this.alllastlist[5].marcode,
						marcode7: this.alllastlist[6] == null ? '' : this.alllastlist[6].marcode,
						marcode8: this.alllastlist[7] == null ? '' : this.alllastlist[7].marcode,
						marcode9: this.alllastlist[8] == null ? '' : this.alllastlist[8].marcode,
						marcode10: this.alllastlist[9] == null ? '' : this.alllastlist[9].marcode,
						marcode11: this.alllastlist[10] == null ? '' : this.alllastlist[10].marcode,
						marcode12: this.alllastlist[11] == null ? '' : this.alllastlist[11].marcode,
						marcode13: this.alllastlist[12] == null ? '' : this.alllastlist[12].marcode,
						marcode14: this.alllastlist[13] == null ? '' : this.alllastlist[13].marcode,
						marcode15: this.alllastlist[14] == null ? '' : this.alllastlist[14].marcode,
                        canshuxulie:'zhongbiaofuwufei',

                    },

                    {
                        coding: '税费',
                        shuoming: '维修基金',
                        biaozhun: '-',
                        hejiL: ((allrate.weixiujijin == null || allrate.weixiujijin == '' || allrate.weixiujijin == 0 || allrate.weixiujijin == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.weixiujijin)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
                        hejiE: allrate.weixiujijin || '',

                        xinghao1: this.alllastlist[0].weixiujijin || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].weixiujijin,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].weixiujijin,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].weixiujijin,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].weixiujijin,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].weixiujijin,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].weixiujijin,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].weixiujijin,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].weixiujijin,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].weixiujijin,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].weixiujijin,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].weixiujijin,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].weixiujijin,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].weixiujijin,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].weixiujijin,
                        canshuxulie:'weixiujijin',
                    },
                    {
                        coding: '-',
                        shuoming: '其他税费',
                        biaozhun: '-',
                        hejiL: ((allrate.shuifeiqitashuifei == null || allrate.shuifeiqitashuifei == '' || allrate.shuifeiqitashuifei == 0 || allrate.shuifeiqitashuifei == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.shuifeiqitashuifei)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
                        hejiE: allrate.shuifeiqitashuifei || '',

                        xinghao1: this.alllastlist[0].shuifeiqitashuifei || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].shuifeiqitashuifei,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].shuifeiqitashuifei,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].shuifeiqitashuifei,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].shuifeiqitashuifei,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].shuifeiqitashuifei,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].shuifeiqitashuifei,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].shuifeiqitashuifei,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].shuifeiqitashuifei,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].shuifeiqitashuifei,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].shuifeiqitashuifei,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].shuifeiqitashuifei,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].shuifeiqitashuifei,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].shuifeiqitashuifei,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].shuifeiqitashuifei,
                        canshuxulie:'shuifeiqitashuifei',
                    },

                    {
                        coding: '销售费用',
                        shuoming: '销售人工',
                        biaozhun: '-',
                        hejiL: ((allrate.xiaoshoufeiyongrengong == null || allrate.xiaoshoufeiyongrengong == '' || allrate.xiaoshoufeiyongrengong == 0 || allrate.xiaoshoufeiyongrengong == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.xiaoshoufeiyongrengong)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
                        hejiE: allrate.xiaoshoufeiyongrengong || '',

                        xinghao1: this.alllastlist[0].xiaoshoufeiyongrengong || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].xiaoshoufeiyongrengong,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].xiaoshoufeiyongrengong,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].xiaoshoufeiyongrengong,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].xiaoshoufeiyongrengong,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].xiaoshoufeiyongrengong,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].xiaoshoufeiyongrengong,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].xiaoshoufeiyongrengong,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].xiaoshoufeiyongrengong,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].xiaoshoufeiyongrengong,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].xiaoshoufeiyongrengong,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].xiaoshoufeiyongrengong,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].xiaoshoufeiyongrengong,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].xiaoshoufeiyongrengong,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].xiaoshoufeiyongrengong,
                        canshuxulie:'xiaoshoufeiyongrengong',
                    },
                    {
                        coding: '-',
                        shuoming: '销售组织运营',
                        biaozhun: '-',
                        hejiL: ((allrate.xiaoshouzuzhiyunying == null || allrate.xiaoshouzuzhiyunying == '' || allrate.xiaoshouzuzhiyunying == 0 || allrate.xiaoshouzuzhiyunying == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.xiaoshouzuzhiyunying)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
                        hejiE: allrate.xiaoshouzuzhiyunying || '',

                        xinghao1: this.alllastlist[0].xiaoshouzuzhiyunying || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].xiaoshouzuzhiyunying,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].xiaoshouzuzhiyunying,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].xiaoshouzuzhiyunying,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].xiaoshouzuzhiyunying,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].xiaoshouzuzhiyunying,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].xiaoshouzuzhiyunying,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].xiaoshouzuzhiyunying,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].xiaoshouzuzhiyunying,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].xiaoshouzuzhiyunying,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].xiaoshouzuzhiyunying,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].xiaoshouzuzhiyunying,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].xiaoshouzuzhiyunying,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].xiaoshouzuzhiyunying,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].xiaoshouzuzhiyunying,
                        canshuxulie:'xiaoshouzuzhiyunying',
                    },
                    {
                        coding: '研发费用',
                        shuoming: '研发人工',
                        biaozhun: '-',
                        hejiL: ((allrate.yanfarengong == null || allrate.yanfarengong == '' || allrate.yanfarengong == 0 || allrate.yanfarengong == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.yanfarengong)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
                        hejiE: allrate.yanfarengong || '',

                        xinghao1: this.alllastlist[0].yanfarengong || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].yanfarengong,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].yanfarengong,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].yanfarengong,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].yanfarengong,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].yanfarengong,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].yanfarengong,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].yanfarengong,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].yanfarengong,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].yanfarengong,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].yanfarengong,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].yanfarengong,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].yanfarengong,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].yanfarengong,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].yanfarengong,
                        canshuxulie:'yanfarengong',
                    },
                    {
                        coding: '-',
                        shuoming: '研发组织运营',
                        biaozhun: '-',
                        hejiL: ((allrate.yanfayunying == null || allrate.yanfayunying == '' || allrate.yanfayunying == 0 || allrate.yanfayunying == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.yanfayunying)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
                        hejiE: allrate.yanfayunying || '',

                        xinghao1: this.alllastlist[0].yanfayunying || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].yanfayunying,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].yanfayunying,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].yanfayunying,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].yanfayunying,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].yanfayunying,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].yanfayunying,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].yanfayunying,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].yanfayunying,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].yanfayunying,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].yanfayunying,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].yanfayunying,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].yanfayunying,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].yanfayunying,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].yanfayunying,
                        canshuxulie:'yanfayunying',
                    },
                    {
                        coding: '直接费用小计',
                        shuoming: '-',
                        biaozhun: '-',
                        hejiL: ((allrate.zhijiefeiyongxiaoji == null || allrate.zhijiefeiyongxiaoji == '' || allrate.zhijiefeiyongxiaoji == 0 || allrate.zhijiefeiyongxiaoji == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.zhijiefeiyongxiaoji)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
                        hejiE: allrate.zhijiefeiyongxiaoji || '',
                        xinghao1: this.alllastlist[0].zhijiefeiyongxiaoji || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].zhijiefeiyongxiaoji,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].zhijiefeiyongxiaoji,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].zhijiefeiyongxiaoji,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].zhijiefeiyongxiaoji,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].zhijiefeiyongxiaoji,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].zhijiefeiyongxiaoji,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].zhijiefeiyongxiaoji,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].zhijiefeiyongxiaoji,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].zhijiefeiyongxiaoji,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].zhijiefeiyongxiaoji,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].zhijiefeiyongxiaoji,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].zhijiefeiyongxiaoji,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].zhijiefeiyongxiaoji,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].zhijiefeiyongxiaoji,
                        canshuxulie:'zhijiefeiyongxiaoji',
                    },
                    {
                        message: '经营贡献',
                        coding: '经营贡献',
                        shuoming: '-',
                        biaozhun: '-',
                        hejiL: ((allrate.jingyinggongxiansan == null || allrate.jingyinggongxiansan == '' || allrate.jingyinggongxiansan == 0 || allrate.jingyinggongxiansan == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.jingyinggongxiansan)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
                        hejiE: allrate.jingyinggongxiansan || '',
                        xinghao1: this.alllastlist[0].jingyinggongxiansan || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].jingyinggongxiansan,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].jingyinggongxiansan,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].jingyinggongxiansan,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].jingyinggongxiansan,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].jingyinggongxiansan,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].jingyinggongxiansan,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].jingyinggongxiansan,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].jingyinggongxiansan,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].jingyinggongxiansan,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].jingyinggongxiansan,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].jingyinggongxiansan,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].jingyinggongxiansan,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].jingyinggongxiansan,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].jingyinggongxiansan,
                        canshuxulie:'jingyinggongxiansan',
                    },
                    {
                        coding: '经营贡献率',
                        shuoming: '-',
                        biaozhun: '-',
                        hejiL: '-',
                        hejiE: allrate.jingyinggongxianlv || '',
                        xinghao1: this.alllastlist[0].jingyinggongxianlv || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].jingyinggongxianlv,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].jingyinggongxianlv,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].jingyinggongxianlv,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].jingyinggongxianlv,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].jingyinggongxianlv,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].jingyinggongxianlv,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].jingyinggongxianlv,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].jingyinggongxianlv,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].jingyinggongxianlv,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].jingyinggongxianlv,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].jingyinggongxianlv,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].jingyinggongxianlv,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].jingyinggongxianlv,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].jingyinggongxianlv,
                        canshuxulie:'jingyinggongxianlv',
//39
                    },
                    {
                        message: '平台费用',
                        coding: '销售费用',
                        shuoming: '-',
                        biaozhun: '-',
                        hejiL: ((allrate.pingtaixiaoshoufeiyong == null || allrate.pingtaixiaoshoufeiyong == '' || allrate.pingtaixiaoshoufeiyong == 0 || allrate.pingtaixiaoshoufeiyong == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.pingtaixiaoshoufeiyong)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
                        hejiE: allrate.pingtaixiaoshoufeiyong || '',
                        xinghao1: this.alllastlist[0].pingtaixiaoshoufeiyong || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].pingtaixiaoshoufeiyong,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].pingtaixiaoshoufeiyong,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].pingtaixiaoshoufeiyong,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].pingtaixiaoshoufeiyong,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].pingtaixiaoshoufeiyong,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].pingtaixiaoshoufeiyong,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].pingtaixiaoshoufeiyong,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].pingtaixiaoshoufeiyong,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].pingtaixiaoshoufeiyong,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].pingtaixiaoshoufeiyong,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].pingtaixiaoshoufeiyong,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].pingtaixiaoshoufeiyong,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].pingtaixiaoshoufeiyong,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].pingtaixiaoshoufeiyong,
                        canshuxulie:'pingtaixiaoshoufeiyong',

                    },
                    {
                        coding: '管理费用',
                        shuoming: '-',
                        biaozhun: '-',
                        hejiL: ((allrate.pingtaiguanlifeiyong == null || allrate.pingtaiguanlifeiyong == '' || allrate.pingtaiguanlifeiyong == 0 || allrate.pingtaiguanlifeiyong == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.pingtaiguanlifeiyong)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
                        hejiE: allrate.pingtaiguanlifeiyong || '',
                        xinghao1: this.alllastlist[0].pingtaiguanlifeiyong || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].pingtaiguanlifeiyong,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].pingtaiguanlifeiyong,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].pingtaiguanlifeiyong,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].pingtaiguanlifeiyong,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].pingtaiguanlifeiyong,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].pingtaiguanlifeiyong,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].pingtaiguanlifeiyong,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].pingtaiguanlifeiyong,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].pingtaiguanlifeiyong,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].pingtaiguanlifeiyong,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].pingtaiguanlifeiyong,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].pingtaiguanlifeiyong,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].pingtaiguanlifeiyong,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].pingtaiguanlifeiyong,
                        canshuxulie:'pingtaiguanlifeiyong',

                    },
                    {
                        coding: '研发费用',
                        shuoming: '-',
                        biaozhun: '-',
                        hejiL: ((allrate.pingtaiyanfafeiyong == null || allrate.pingtaiyanfafeiyong == '' || allrate.pingtaiyanfafeiyong == 0 || allrate.pingtaiyanfafeiyong == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.pingtaiyanfafeiyong)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
                        hejiE: allrate.pingtaiyanfafeiyong || '',
                        xinghao1: this.alllastlist[0].pingtaiyanfafeiyong || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].pingtaiyanfafeiyong,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].pingtaiyanfafeiyong,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].pingtaiyanfafeiyong,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].pingtaiyanfafeiyong,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].pingtaiyanfafeiyong,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].pingtaiyanfafeiyong,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].pingtaiyanfafeiyong,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].pingtaiyanfafeiyong,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].pingtaiyanfafeiyong,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].pingtaiyanfafeiyong,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].pingtaiyanfafeiyong,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].pingtaiyanfafeiyong,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].pingtaiyanfafeiyong,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].pingtaiyanfafeiyong,
                        canshuxulie:'pingtaiyanfafeiyong',

                    },
                    {
                        coding: '平台费用小计',
                        shuoming: '-',
                        biaozhun: '-',
                        hejiL: ((allrate.pingtaifeiyongxiaoji == null || allrate.pingtaifeiyongxiaoji == '' || allrate.pingtaifeiyongxiaoji == 0 || allrate.pingtaifeiyongxiaoji == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.pingtaifeiyongxiaoji)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
                        hejiE: allrate.pingtaifeiyongxiaoji || '',
                        xinghao1: this.alllastlist[0].pingtaifeiyongxiaoji || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].pingtaifeiyongxiaoji,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].pingtaifeiyongxiaoji,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].pingtaifeiyongxiaoji,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].pingtaifeiyongxiaoji,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].pingtaifeiyongxiaoji,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].pingtaifeiyongxiaoji,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].pingtaifeiyongxiaoji,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].pingtaifeiyongxiaoji,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].pingtaifeiyongxiaoji,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].pingtaifeiyongxiaoji,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].pingtaifeiyongxiaoji,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].pingtaifeiyongxiaoji,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].pingtaifeiyongxiaoji,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].pingtaifeiyongxiaoji,
                        canshuxulie:'pingtaifeiyongxiaoji',

                    },
                    {
                        message: '利润',
                        coding: '利润',
                        shuoming: '-',
                        biaozhun: '-',
                        hejiL: ((allrate.lirunsan == null || allrate.lirunsan == '' || allrate.lirunsan == 0 || allrate.lirunsan == '0') || ((allrate.buhanshuishouru == null || allrate.buhanshuishouru == '' || allrate.buhanshuishouru == 0 || allrate.buhanshuishouru == '0'))) ? 0 : (new big(parseFloat(allrate.lirunsan)).div(parseFloat(allrate.buhanshuishouru))).toFixed(2).toString() || '',
                        hejiE: allrate.lirunsan || '',
                        xinghao1: this.alllastlist[0].lirunsan || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].lirunsan,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].lirunsan,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].lirunsan,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].lirunsan,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].lirunsan,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].lirunsan,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].lirunsan,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].lirunsan,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].lirunsan,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].lirunsan,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].lirunsan,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].lirunsan,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].lirunsan,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].lirunsan,
                        canshuxulie:'lirunsan',

                    },
                    {
                        coding: '利润率',
                        shuoming: '-',
                        biaozhun: '-',
                        hejiL: '-',
                        hejiE: allrate.lirunlirunlv || '',
                        xinghao1: this.alllastlist[0].lirunlirunlv || '',
                        xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].lirunlirunlv,
                        xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].lirunlirunlv,
                        xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].lirunlirunlv,
                        xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].lirunlirunlv,
						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].lirunlirunlv,
						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].lirunlirunlv,
						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].lirunlirunlv,
						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].lirunlirunlv,
						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].lirunlirunlv,
						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].lirunlirunlv,
						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].lirunlirunlv,
						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].lirunlirunlv,
						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].lirunlirunlv,
						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].lirunlirunlv,
                        canshuxulie:'lirunlirunlv',
//45
                    },];


                this.ProMain.zhongduanchengjiaojia = allrate.zhongduanchengjiaojia?(parseFloat(allrate.zhongduanchengjiaojia).toFixed(2)):0 ;
                this.ProMain.zhuanyingshangmaolilv = allrate.zhuanyingshangmaolilv?(parseFloat(allrate.zhuanyingshangmaolilv).toFixed(2)):0 ;

                //加载总利率
                this.jiazaizonglilv(allrate);

                //比较毛利率
                this.shifoudadaoyinglimubiao();


            },


            //加载总利率
            jiazaizonglilv(q){

                //存在总额
                if (q) {

                    console.log(q,'q.savenum')

                    //遍历总额
                    for (var c in q) {

                        if(q[c]!=null&&q[c]!=''){

                            //遍历表
                            for (var ccc in this.tableData) {



                                //若参数序列对应结果key
                                if (this.tableData[ccc].canshuxulie == c) {



                                    //取平均值  zhongduanchengjiaojia终端成交价   zhuanyingshangmaolilv专营商毛利率   onemoney单台一级供价  zhekoulv折扣率  wuliufeiyongdanweitiji单台体积  dantaianzhuangfei单台安装费
                                    this.divfangfa(c,'zhongduanchengjiaojia',ccc,'hejiE',q[c],q.savenum);
                                    this.divfangfa(c,'zhuanyingshangmaolilv',ccc,'hejiE'.hejiE,q[c],q.savenum);
                                    this.divfangfa(c,'onemoney',ccc,'hejiE',q[c],q.savenum);
                                    this.divfangfa(c,'zhekoulv',ccc,'hejiE',q[c],q.savenum);
                                    this.divfangfa(c,'zhekoulv',ccc,'hejiL',q[c],q.savenum);
                                    this.divfangfa(c,'wuliufeiyongdanweitiji',ccc,'hejiE',q[c],q.savenum);
                                    this.divfangfa(c,'dantaianzhuangfei',ccc,'hejiE',q[c],q.savenum);



                                    //shenqingdanjia申请单价
                                    this.divfangfa(c,'shenqingdanjia',ccc,'hejiE',q.dingdanjine,q.productNum);


                                    //dantaichengben单台成本
                                    this.divfangfa(c,'dantaichengben',ccc,'hejiE',q.maolichengbenheji,q.productNum);




                                    //maolimaolilv材料毛利率
                                    this.divfangfa(c,'maolimaolilv',ccc,'hejiE',q.maolimaoli,q.buhanshuishouru);


                                    //jingyinggongxianlv经营贡献率
                                    this.divfangfa(c,'jingyinggongxianlv',ccc,'hejiE',q.jingyinggongxiansan,q.buhanshuishouru);

                                    //lirunlirunlv利润率
                                    this.divfangfa(c,'lirunlirunlv',ccc,'hejiE',q.lirunsan,q.buhanshuishouru);




                                    //盈利情况 材料毛利 合计率
                                    this.divfangfa(c,'yinglicailiaomaoli',ccc,'hejiL',q.maolimaoli,q.buhanshuishouru);

                                    //盈利情况 经营贡献 合计率
                                    this.divfangfa(c,'jingyinggongxian',ccc,'hejiL',q.jingyinggongxiansan,q.buhanshuishouru);

                                    //盈利情况 利润 合计率
                                    this.divfangfa(c,'yinglilirun',ccc,'hejiL',q.lirunsan,q.buhanshuishouru);



                                }




                            }

                        }



                    }

                }

            },



            divfangfa(c,c1,ccc,heji,z,z1){

                if(c==c1){

                    if(z!=''&&z1!=''&&z!=0&&z1!=0){


                        this.tableData[ccc][heji] = (new big(parseFloat(z)).div(parseFloat(z1)).toString());


                    }else{

                        this.tableData[ccc][heji] = 0;

                    }

                }



            },




            //判断是否达到盈利目标
            shifoudadaoyinglimubiao() {


                var mailizong = 0;
                var maolibiao = 0;
                var geshu = 0;

                for (var g in this.alllastlist) {

                    geshu++;

                    console.log(this.alllastlist[g].maolimaolilv, '总毛利')

                    this.zongmaolilv += parseFloat(this.alllastlist[g].maolimaolilv);


                    console.log(this.alllastlist[g].sunyibiaocailiaomaolilv, '总毛利表')

                    this.zongmaolilvbiao += parseFloat(this.alllastlist[g].sunyibiaocailiaomaolilv);


                    console.log(this.alllastlist[g].jingyinggongxiansan, '经营贡献总')

                    this.jingyinggongxiangzong += parseFloat(this.alllastlist[g].jingyinggongxiansan);


                    console.log(this.alllastlist[g].lirunsan, '利润总')

                    this.lirunzong += parseFloat(this.alllastlist[g].lirunsan);

                }


                mailizong = new big(this.zongmaolilv).div(geshu).toString();
                maolibiao = new big(this.zongmaolilvbiao).div(geshu).toString();
                this.zongmaolilvbiao = maolibiao;
                this.zongmaolilv = parseInt((mailizong *= 100));
                console.log(this.zongmaolilvbiao, '总毛利率表值')
                console.log(this.zongmaolilv, '总毛利率值')


                if (this.tableData && this.tableData.length > 0 ? this.tableData[45].hejiE == null || this.tableData[45].hejiE == '' ? false : true : false) {

                    if (this.tableData[45].hejiE >= 0.25) {

                        this.xianshinage = 0;

                    } else {

                        this.xianshinage = 1;
                    }

                }


            },


            // //前后台交互
            // getconfigs(q) {
            //
            //     console.log(q, '?aa?')
            //
            //     if ((q == 'zancun' || q == 'tijiao' || q == 1) && !(this.ProMain.bidway && this.ProMain.pdpay != null && this.ProMain.fdpay != null && this.ProMain.mdpay != null && this.ProMain.ldpay != null && this.ProMain.fdpayday != null && this.ProMain.mdpayday != null && this.ProMain.ldpayday != null && this.ProMain.quyu)) {
            //         this.$msg.msge("请先填写完整信息")
            //     } else {
            //         this.jinxingjiaohu(q);
            //     }
            //
            // },


            // jinxingjiaohu(q) {
            //
            //     this.jisuan(this.gouzaocanshu(q, 1, this.marcode));
            //
            // },


            //构造参数 q 0加载信息   1计算   s物料所在列   marcode物料号
            //返回RateFormulaRenewXiangmucanshu entity
            gouzaocanshu(q, s, marcode) {

                console.log(q, s, marcode, '看看呃呃呃')

                this.xianshinage = 9;

                this.jingyinggongxiangzong = 0;

                this.lirunzong = 0;

                this.zongmaolilvbiao = 0;

                this.zongmaolilv = 0;


                var s17s14s3s12 = {};

                var zhencanpr = {};

                console.log('22222?????')

                if (!this.shoucijiaohu) {

                    //键值对真参
                    s17s14s3s12 =
                        {
                            marcode: marcode,
                            s17: this.tableData[9]['xinghao' + (s)],
                            s14: this.tableData[21]['xinghao' + (s)],
                            s3: this.tableData[30]['xinghao' + (s)],
                            s12: this.tableData[4]['xinghao' + (s)],
                            s99: this.tableData[6]['xinghao' + (s)],
                            s88:this.tableData[16]['xinghao' + (s)],//BOM成本

                        };

                    //产品详情真参
                    zhencanpr = {

                        'productId': marcode,
                        'productNum': this.tableData[8]['xinghao' + (s)],

                    };

                    console.log(s17s14s3s12, '看看有没有?????')

                }
                ;


                //键值对假参
                var dd = {
                    marcode: marcode,
                    s17: '0',
                    s14: '0',
                    s3: '0',
                    s12: '0',
                    s99:'0',//单台一级供价
                    s88:'0',//BOM成本
                };


                //产品详情假参
                var jiacanpr = {

                    'productId': marcode,
                    'productNum': '0'

                };


                //后台接口入参
                var inputto = {
                    "islengku":"1",
                    //"shiyongren": q == 0 ? "" : this.ProMain.shiyongren,//使用人usercode
                    //"xuanzhongren": q == 0 ? "" : this.ProMain.xuanzhongren,//使用人username
                    // "songdachengshi": q == 0 ? "" : this.ProMain.songdachengshi,
                    // "songdadizhi": q == 0 ? "" : this.ProMain.songdadizhi,

                    "baoxiuqi": q == 0 ? "" : this.repairtype,
                    "savestatus": q == 0 ? null : q == 'zancun' ? 0 : (q == 'tijiao' || q == 'chongxintijiao') ? 1 : null,
                    "f28": q == 0 ? "0" : this.ProMain.pdpay + '',
                    "f6": q == 0 ? "0" : this.ProMain.fdpay + '',
                    "f23": q == 0 ? "0" : this.ProMain.fdpayday + '',
                    "f27": q == 0 ? "0" : this.ProMain.mdpay + '',
                    "f13": q == 0 ? "0" : this.ProMain.mdpayday + '',
                    "f34": q == 0 ? "0" : this.ProMain.ldpay + '',
                    "f30": q == 0 ? "0" : this.ProMain.ldpayday + '',
                    "bidway": q == 0 ? "zckceshi" : this.ProMain.bidway + '',
                    "jianzhidui": q == 0 ? dd : s17s14s3s12,
                    "proProductInfo": q == 0 ? jiacanpr : zhencanpr,
                    //"quyu": this.ProMain.quyu,

                };


                if(q != 0 && this.ProMain.youxiaoqistart != null && this.ProMain.youxiaoqistart != '' && this.ProMain.youxiaoqistart != 'NaN-NaN-NaN' && this.ProMain.youxiaoqi != null && this.ProMain.youxiaoqi != ''&& this.ProMain.youxiaoqi != 'NaN-NaN-NaN'){
                    inputto.youxiaoqistart=this.$util.riQi(this.ProMain.youxiaoqistart);
                    inputto.youxiaoqi=this.$util.riQi(this.ProMain.youxiaoqi);



                }

                return inputto;

            },


            jisuan(inputto, q) {

                console.log(inputto, '看看传参')

                //调接口回调方法
                ss.FormulaNew.getbyformula(inputto).then(rd => {

                    console.log(rd, '看看返回的信息****')

                    this.jiazaijieguoxinxi(rd);

                    //重新提交的提交成功
                    if (rd.f == true && q == 'chongxintijiao') {

                        var shanchu = {

                            id: this.daishanchubanben

                        }

                        ss.FormulaNew.luojishanchu(shanchu).then(rd => {

                            //删除成功
                            if (rd.f == true) {

                                this.$msg.alerts("提交成功！", () => {
                                    //刷新右上角的代办个数
                                    this.$store.dispatch("searchTasktotal")
                                    //跳转回系统的代办列表
                                    this.$router.push({path: '/personal/dealCenter'})
                                })

                            }

                        })

                    } else if (rd.f == true && q == 'tijiao') {

                        this.$msg.msgs("提交成功")

                        this.$router.push({path: '/pricenew'})

                    }


                    //下部列表所有计算查询返回信息
                    var listrd = rd.marnesList;

                    var allrate = rd.allrate;

                    console.log(allrate)

                    this.allratemap = rd.allrate;

                    //加载列
                    this.addbiaotilie(listrd, allrate);

                    this.shoucijiaohu = false;

                });

            },


            // //翻页
            // gotonextpage() {
            //
            //     for (var j in this.alllastlist) {
            //
            //         if (this.alllastlist.length >= this.value3 && this.value3 == j) {
            //
            //             //   替换数据
            //
            //             this.ProMain.zhuanyingshangmaolilv = this.alllastlist[j].zhuanyingshangmaolilv;
            //
            //
            //             this.tableData = [{
            //                 message: '基本信息',
            //                 coding: '编码',
            //                 shuoming: '-',
            //                 biaozhun: '-',
            //                 hejiL: '-',
            //                 hejiE: '-',
            //                 xinghao: this.alllastlist[j].marcode,
            //                 xiugai: '-',
            //             }, {
            //                 coding: '型号',
            //                 biaozhun: '-',
            //                 shuoming: '-',
            //                 hejiL: '-',
            //                 hejiE: '-',
            //                 xinghao: this.alllastlist[j].productLevel,
            //                 xiugai: '-',
            //             }, {
            //                 coding: '产品大类',
            //                 biaozhun: '-',
            //                 shuoming: '-',
            //                 hejiL: '-',
            //                 hejiE: '-',
            //                 xinghao: this.alllastlist[j].typeLevel,
            //                 xiugai: '-',
            //             }, {
            //                 coding: '产品系列',
            //                 biaozhun: '-',
            //                 shuoming: '-',
            //                 hejiL: '-',
            //                 hejiE: '-',
            //                 xinghao: this.alllastlist[j].opeLevel,
            //                 xiugai: '-',
            //             }, {
            //                 message: '收入',
            //                 coding: '单台一级供价',
            //                 biaozhun: '-',
            //                 shuoming: '-',
            //                 hejiL: '-',
            //                 hejiE: this.alllastlist[j].onemoney,
            //                 xinghao: this.alllastlist[j].onemoney,
            //                 xiugai: '-',
            //             }, {
            //                 coding: '折扣率',
            //                 biaozhun: '-',
            //                 shuoming: '-',
            //                 hejiL: '51%',
            //                 hejiE: '51%',
            //                 xinghao: '51%',
            //                 xiugai: '-',
            //             },
            //                 {
            //                     coding: '销量',
            //                     biaozhun: '-',
            //                     shuoming: '-',
            //                     hejiL: '-',
            //                     hejiE: this.alllastlist[j].productNum,
            //                     xinghao: this.alllastlist[j].productNum,
            //
            //                 },
            //                 {
            //                     coding: '申请单价(含税)',
            //                     biaozhun: '-',
            //                     shuoming: '-',
            //                     hejiL: '-',
            //                     hejiE: '26,000',
            //                     xinghao: '26,000',
            //
            //                 },
            //                 {
            //                     coding: '订单金额',
            //                     biaozhun: '-',
            //                     shuoming: '-',
            //                     hejiL: '-',
            //                     hejiE: '130,000',
            //                     xinghao: '130,000',
            //
            //                 },
            //                 {
            //                     coding: '不含税订单收入',
            //                     biaozhun: '-',
            //                     shuoming: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '盈亏平衡含税价',
            //                     biaozhun: '-',
            //                     shuoming: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     message: '盈利情况',
            //                     coding: '材料毛利',
            //                     shuoming: '-',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '经营贡献',
            //                     biaozhun: '-',
            //                     shuoming: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '利润',
            //                     biaozhun: '-',
            //                     shuoming: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     message: '毛利',
            //                     coding: '单台成本',
            //                     shuoming: '测算当月BOM成本',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '成本合计',
            //                     biaozhun: '-',
            //                     shuoming: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '毛利',
            //                     biaozhun: '-',
            //                     shuoming: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '材料毛利率',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     shuoming: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     message: '直接费用',
            //                     coding: '制造费用',
            //                     shuoming: '材料的制造费用率',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '物流费用',
            //                     shuoming: '单位体积',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '运费',
            //                     shuoming: '260',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '安装费用',
            //                     shuoming: '单台安装费',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '安装费',
            //                     shuoming: '-',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '维修费',
            //                     shuoming: '18年到产品实际费用',
            //                     biaozhun: '超低温:0.38%',
            //                     hejiL: '0.38',
            //                     hejiE: '437',
            //                     xinghao: '427',
            //
            //                 },
            //                 {
            //                     coding: '备件费',
            //                     shuoming: '18年到产品实际费用',
            //                     biaozhun: '超低温:0.38%-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '退换机',
            //                     shuoming: '18年到产品实际费用',
            //                     biaozhun: '超低温:0.38%',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '资金成本',
            //                     shuoming: '资金成本损失',
            //                     biaozhun: '年度6个点,月度0.5%',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '中标服务费',
            //                     shuoming: '-',
            //                     biaozhun: '-',
            //                     hejiL: '0.0%',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '税费',
            //                     shuoming: '维修基金',
            //                     biaozhun: '12',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '其他税费',
            //                     shuoming: '0.98%',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '销售费用',
            //                     shuoming: '销售人工',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '销售组织运营',
            //                     shuoming: '0.36%',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '研发费用',
            //                     shuoming: '研发人工',
            //                     biaozhun: '超低温',
            //                     hejiL: '1.12%',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '研发组织运营',
            //                     shuoming: '超低温',
            //                     biaozhun: '0.35%',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '直接费用小计',
            //                     shuoming: '-',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     message: '经营贡献',
            //                     coding: '经营贡献',
            //                     shuoming: '0.36%',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '经营贡献率',
            //                     shuoming: '0.36%',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     message: '平台费用',
            //                     coding: '销售费用',
            //                     shuoming: '0.36%',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '管理费用',
            //                     shuoming: '0.36%',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '研发费用',
            //                     shuoming: '0.36%',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '平台费用小计',
            //                     shuoming: '0.36%',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     message: '利润',
            //                     coding: '利润',
            //                     shuoming: '0.36%',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '利润率',
            //                     shuoming: '0.36%',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },]
            //
            //
            //         }
            //
            //     }
            //
            //
            // },


            //提交页面跳转方法
            gotosubmitok() {

                // var inputto = {
                //
                //     "toubiaofangshi": this.formLabelAlign.toubiaofangshi
                //
                // };


            },
            // 关闭新手引导页
            closeIt(){
				this.showOrhide = false;
				if(this.checked){
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}else{
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}
            },
            nextStep(i){
				if(this.status ==1){
					if(this.checked){
                        ss.salesList.toshow(this.toshow,this.checked).then(rd => {
                        	console.log(rd)
                        	this.showOrhide = false;
                        })
                    }else{
                        ss.salesList.toshow(this.toshow,this.checked).then(rd => {
                        	console.log(rd)
                        	this.showOrhide = false;
                        })
                    }
				}
			}

        }
    }

</script>
<style scoped>
    .h-piece, .h-table {
        margin: 20px;
    }


    .xingxing {
        position: absolute;
        top: 0;
        left: -89px;
        color: red;
        font-size: 0.2rem;
    }

    .selectorBox {
        width: 100%;
        padding: 0.54rem 0.28rem 0 0.25rem;
    }

    .selectorBox .text {
        margin-left: 0.38rem;
        font-size: 0.18rem;
        color: #4a4a4a;
        position: relative;
        background-color: rgb(118, 201, 118);
    }

    .selectorBox .text::before {
        content: "*";
        position: absolute;
        top: 0;
        left: -7px;
        color: red;
        font-size: 0.2rem;
    }

    .selectorBox .selector {
        margin-left: 0.38rem;
        margin-top: 20px;
        display: flex;
    }

    .selectorBox .selector .button {
        width: 65px;
        padding: 10px;
        color: #b7b7b7;
        border: 1px solid #dcdfe1;
        text-align: center;
        line-height: 20px;
        cursor: pointer;
    }

    .selectorBox .selector .button.active {
        color: #fff;
        background: #238cfd;
        border: 1px solid #238cfd;
    }

    .tip {
        margin-left: 1.6rem;
        color: #b0b0b0;
        font-size: 0.2rem;
        margin-top: 10px;
    }

    .h-bgccc {
        background: #edf5fa;
        border-color: #959595;
        color: #92999e;
    }

    .drags {
        background-color: #ffffff;
        margin-bottom: 30px;
    }

    .message .h-formbLine .h-elformWrap-2 {
        width: 33.3333%;
    }

	.l-style {
	    width: 100%;
	    height: auto;
	    font-size: 0.2rem;
	    color: #4a4a4a;
	    display: flex;
	    align-items: center;
	    justify-content: flex-start;
	    padding-left: 0.7rem;
	}

	.l-style div {
	    flex-shrink: 0;
	}

	.l-styleBox {
	    display: flex;
	    justify-content: flex-start;
	    align-items: center;
		width: 90%;
		flex-wrap: wrap;
	}

	.l-styleBox .l-stylelist {
	    display: flex;
	    justify-content: flex-start;
	    align-items: center;
		flex-wrap: wrap;
	    margin-left: 0.1rem;
		margin-bottom: 0.1rem;
	    cursor: pointer;
	}

	.l-styleBox .l-stylelist .l-styletext {
	    padding: 0.05rem 0.1rem;
	    border-radius: 0.3rem;
	    background: #2686e7;
	    color: #fff;
	    font-size: 0.16rem;
	    position: relative;
	    text-align: center;
	    cursor: pointer;
	}

	/* .l-styleBox .l-stylelist:first-child {
	    margin-left: 0;
	} */

	.l-styleBox .l-stylelist .l-styletext .l-styledel {
	    position: absolute;
	    top: -6px;
	    right: -5px;
	    width: 0.16rem;
	    height: 0.16rem;
	    text-align: center;
	    line-height: 0.16rem;
	    font-size: 0.12rem;
	    color: #fff;
	    background: #ccc;
	    border-radius: 50%;
	    display: none;
	    cursor: pointer;
	}

	.l-styleBox .l-stylelist .l-styletext:hover .l-styledel {
	    display: block;
	}
	.tan {
	    margin: 30px 0 0 0;
	}
</style>
<style>
	.message .h-formbLine .h-elformWrap-1.ljjrange .el-form-item__label {
	    width: 12.5%;
	}

	.message .h-formbLine .h-elformWrap-1.ljjrange .el-form-item__content {
	    width: 87.5%;
	}
    .message.h-formbLine .el-form-item__content .el-input__inner {
        width: 100% !important;
    }

    .message .h-formbLine .el-form-item__label {
        width: 43%;
    }

    .message .h-formbLine .el-form-item__content {
        width: 57%;
    }

    .selectorBox .el-input-group__append {
        background: #238cfd;
        color: #fff
    }

    .selectorBox .el-upload-list {
        display: none;
    }


    .drags .el-slider__button-wrapper .el-slider__button {
        background: url(../../../assets/images/drag.png) center/cover;
        border: 0;
        border-radius: 0;
        width: 20px;
        height: 20px;
    }

    .fenyes .h-pagiLabel {
        display: none;
    }

    .fenyes .el-pagination .el-pagination__sizes {
        display: none;
    }
</style>


<style>

    .el-table .hidden-row {
        display: none;

    }

    .ljjrange .el-range-editor .el-range-separator {
        line-height: 18px;
    }
	.tan .h-formbLine .el-form-item__label {
	    width: 47%;
	}

	.tan .h-formbLine .el-form-item__content {
	    width: 53%
	}

	.tan .h-formbLine .h-elformWrap-2 {
	    width: 50%;
	}

	.tan .h-elformWrap-1 .el-form-item__label {
	    width: 20%;
	}

	.tan .h-elformWrap-1 .el-form-item__content {
	    width: 80%;
	}
	.ljjtableenterlkn .h-tableInput .el-input__inner{
		padding: 0.05rem 0.1rem;
	}
	.ljjtableenterlkn .h-tableInput .el-input__icon{
		line-height: 0.25rem;
	}
</style>

<style scoped lang="scss">
    .bottomTip{
		position: absolute;
		left: 49.7%;
		bottom: 0.3rem;
		transform: translateX(-50%);
	}
	.newtext{
		font-size: 0.28rem;
		color: white;
		position: absolute;
		top:0.2rem;
		left: 50%;
		transform: translateX(-50%);
		font-weight: bold;
		text-shadow:1px 1px 4px #2785E7;
		z-index: 2;
	}
    .leaderBox{
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.4);
		position: fixed;
		z-index: 99999;
		overflow: hidden;
		top: 0;
		left: 0;
		.leaderbg{
			width: 100%;
			height: 100%;
		}
		.steps{
			position: absolute;
			z-index: 1;
		}
		.step1{
			top:6.4rem;
			left: 10.8rem;
			width:3.8rem;
			height: 1.8rem;
		}
		.stepbtn{
			width: 1.9rem;
			height: 0.6rem;
			border: 0.03rem solid #FFFFFF;
			background-color: rgba(0,0,0,0.1);
			border-radius: 5px;
			display: flex;
			justify-content: center;
			line-height: 0.5rem;
			position: absolute;
			z-index: 99;
			bottom: 0.65rem;
			left: 50%;
			transform: translateX(-50%);
			font-size: 0.27rem;
			letter-spacing: 2px;
			color: white;
			cursor: pointer;
		}
		.closeIt{
			width: 0.3rem;
			height: 0.3rem;
			position: absolute;
			top: 0.2rem;
			right: 0.2rem;
			cursor: pointer;
		}
	}
</style>


